// English translations - Complete
export default {
  // Navigation
  nav: {
    home: 'Home',
    dashboard: 'Dashboard',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    settings: 'Settings',
    admin: 'Admin',
    menu: 'Menu',
    createQuiz: 'Create Quiz',
    createQuestionnaire: 'Create Questionnaire',
    createEvent: 'Create Event',
    quizMusic: 'Quiz Music',
    users: 'Users',
    backToDashboard: 'Back to dashboard'
  },
  
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    confirmDelete: 'Confirm deletion',
    confirmDeleteMessage: 'Are you sure you want to delete',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    true: 'True',
    false: 'False',
    all: 'All',
    none: 'None',
    download: 'Download',
    share: 'Share',
    copy: 'Copy',
    copied: 'Copied!',
    play: 'Play',
    view: 'View',
    actions: 'Actions',
    logoutSuccess: 'Successfully logged out',
    or: 'or',
    and: 'and',
    welcome: 'Welcome',
    required: 'Required',
    optional: 'Optional',
    important: 'Important',
    submit: 'Submit',
    reset: 'Reset',
    start: 'Start',
    stop: 'Stop',
    pause: 'Pause',
    resume: 'Resume',
    finish: 'Finish',
    continue: 'Continue',
    skip: 'Skip',
    retry: 'Retry',
    refresh: 'Refresh',
    more: 'More',
    less: 'Less',
    show: 'Show',
    hide: 'Hide',
    enable: 'Enable',
    disable: 'Disable',
    select: 'Select',
    selected: 'Selected',
    upload: 'Upload',
    uploading: 'Uploading...',
    preview: 'Preview',
    export: 'Export',
    import: 'Import',
    print: 'Print',
    send: 'Send',
    sending: 'Sending...',
    sent: 'Sent',
    receive: 'Receive',
    noResults: 'No results',
    loadMore: 'Load more',
    seeAll: 'See all',
    duplicate: 'Duplicate',
    saving: 'Saving...',
    saveChanges: 'Save changes',
    copy: 'copy',
    showMore: 'Show more',
    showLess: 'Show less',
    from: 'From',
    to: 'To',
    date: 'Date',
    time: 'Time',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    description: 'Description',
    title: 'Title',
    status: 'Status',
    type: 'Type',
    category: 'Category',
    tags: 'Tags',
    notes: 'Notes',
    comments: 'Comments',
    details: 'Details',
    information: 'Information',
    total: 'Total',
    quantity: 'Quantity',
    price: 'Price',
    free: 'Free',
    new: 'New',
    updated: 'Updated',
    created: 'Created',
    deleted: 'Deleted',
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    public: 'Public',
    private: 'Private',
    draft: 'Draft',
    published: 'Published',
    admin: 'Admin',
    user: 'User',
    madeWith: 'Made with',
    backToHome: 'Back to home',
    checking: 'Checking...',
    verification: 'Verification',
    access: 'Access'
  },

  // System messages (toasts, alerts, confirmations)
  messages: {
    success: {
      saved: 'Saved successfully',
      deleted: 'Deleted successfully',
      updated: 'Updated successfully',
      created: 'Created successfully',
      copied: 'Copied!',
      linkCopied: 'Link copied!',
      emailSent: 'Email sent!',
      emailVerified: 'Email verified! Redirecting...',
      emailAlreadyVerified: 'Your email is already verified!',
      verificationEmailSent: '📧 Verification email sent! Check your spam folder too.',
      tableCreated: 'Table created successfully',
      tableUpdated: 'Table updated successfully',
      tableDeleted: 'Table deleted',
      tableAdded: 'Table added',
      guestAssigned: 'Guest assigned',
      guestRemoved: 'Guest removed from table',
      planSaved: 'Plan saved',
      questionDuplicated: 'Question duplicated',
      questionnaireUpdated: 'Questionnaire updated!',
      quizUpdated: 'Quiz updated!',
      responseDeleted: 'Response deleted',
      musicDeleted: 'Music deleted',
      accountCreatedResend: 'Account created! Click "Resend email" to receive the verification link.'
    },
    error: {
      generic: 'An error occurred',
      loading: 'Error loading data',
      saving: 'Error saving',
      deleting: 'Error deleting',
      creating: 'Error creating',
      updating: 'Error updating',
      unauthorized: 'Unauthorized access',
      notFound: 'Item not found',
      quizNotFound: 'Quiz not found',
      questionnaireNotFound: 'Questionnaire not found',
      eventNotFound: 'Event not found',
      sessionNotFound: 'Session not found',
      sessionStarted: 'This session has already started',
      accessDenied: 'You are not authorized to access this page',
      adminOnly: 'Admin access only',
      logoutError: 'Error logging out',
      tooManyAttempts: 'Too many attempts. Try again in a few minutes.',
      sessionExpired: 'Session expired. Please log in again.',
      emailNotVerified: 'Email not yet verified. Check your inbox and spam folder.',
      emailVerifiedNotValidated: 'Email verified but account not validated. Contact administrator.',
      qrCodeNotRecognized: 'QR code not recognized',
      qrCodeWrongEvent: 'This ticket does not belong to this event',
      qrCodeReadError: 'Error reading QR code',
      playbackError: 'Playback error',
      assignmentError: 'Error during assignment'
    },
    validation: {
      required: 'This field is required',
      titleRequired: 'Title is required',
      nameRequired: 'Table name required',
      tableNameRequired: 'Please enter a table name',
      sessionCodeRequired: 'Please enter a session code',
      minQuestions: 'Add at least one question',
      minOneQuestion: 'Minimum 1 question required',
      questionTextRequired: 'All questions must have text',
      minOptions: 'Minimum 2 options required',
      passwordMinLength: 'Password must be at least 8 characters',
      passwordLowercase: 'Password must contain at least one lowercase letter',
      passwordUppercase: 'Password must contain at least one uppercase letter',
      passwordSpecialChar: 'Password must contain at least one special character (e.g., #, @, !)'
    },
    confirm: {
      delete: 'Are you sure you want to delete this item?',
      logout: 'Are you sure you want to log out?'
    }
  },

  pendingValidation: {
    title: 'Verify your email',
    emailSentTo: 'A verification email has been sent to',
    checkInbox: '📧 Click the link in the email to verify your address. Also check your spam folder.',
    accessGranted: '✅ Once your email is verified, you will have immediate access to your account!',
    iVerified: 'I verified my email',
    resendEmail: 'Resend verification email',
    logout: 'Log out'
  },
  
  // Home page
  home: {
    title: 'Welcome to HugoQuiz',
    subtitle: 'Create quizzes, questionnaires and manage your events',
    startFree: 'Get started for free',
    login: 'Login',
    goToDashboard: 'Go to dashboard',
    features: {
      quiz: 'Interactive Quizzes',
      quizDesc: 'Create engaging quizzes with timer and leaderboard',
      quizLive: 'Live Multiplayer Quizzes',
      quizLiveDesc: 'Host live quizzes with participants connected simultaneously',
      questionnaire: 'Conditional Questionnaires',
      questionnaireDesc: 'Smart forms with conditional logic and dynamic navigation',
      events: 'Gift Lists',
      eventsDesc: 'Create lists for weddings, birthdays, births and all your events'
    },
    highlights: {
      timer: 'Customizable timer',
      realTimeScores: 'Real-time scores',
      kahootMusic: 'Kahoot-style music',
      presenterMode: 'Presenter mode',
      liveRanking: 'Live ranking',
      upTo100Players: 'Up to 100 players',
      conditionalLogic: 'IF/ELSE logic',
      questionTypes: '11 question types',
      responseAnalysis: 'Response analysis',
      multiReservations: 'Multiple reservations',
      photoGallery: 'Photo gallery',
      pdfInvitations: 'PDF invitations'
    },
    eventTypes: {
      wedding: 'Wedding',
      birthday: 'Birthday',
      birth: 'Birth',
      baptism: 'Baptism',
      housewarming: 'Housewarming',
      christmas: 'Christmas'
    },
    stats: {
      free: 'Free',
      unlimited: 'Unlimited quizzes',
      questionTypes: 'Question types',
      hdImages: 'HD Images'
    },
    cta: {
      createFirstQuiz: 'Create my first quiz',
      discoverFeatures: 'Discover features',
      watchDemo: 'Watch demo',
      createFreeAccount: 'Create a free account',
      readyToCreate: 'Ready to create something amazing?',
      joinHugoQuiz: 'Join HugoQuiz and transform your events into unforgettable experiences.',
      foreverFree: '100% free, forever.'
    },
    footer: {
      madeWith: 'Made with',
      forYourEvents: 'for your events',
      createdWith: 'Created with'
    },
    sections: {
      allYouNeed: 'Everything you need',
      allYouNeedDesc: 'A complete suite of tools to create unforgettable interactive experiences',
      interactiveQuiz: 'Interactive Quizzes',
      kahootStyle: 'Kahoot Style',
      quizDetailDesc: 'Create engaging quizzes with timer, score system, ambient music and leaderboards. Perfect for education, team buildings or parties with friends!',
      giftLists: 'Gift Lists',
      forAllEvents: 'For all your events',
      giftListDesc: 'Create an elegant gift list, share it with your loved ones and let them easily reserve. Photo gallery, personalized story and PDF invitations included!',
      questionTypesTitle: '11 Question Types',
      questionTypesDesc: 'From classic questions to advanced forms, anything is possible',
      simpleAsHello: 'Simple as hello',
      createShareIn4Steps: 'Create and share in 4 steps'
    },
    quizFeatures: {
      customTimer: 'Customizable timer per question (5-120 sec)',
      kahootMusic: 'Built-in Kahoot-style ambient music',
      leaderboardBonus: 'Leaderboard with speed bonus',
      sevenQuestionTypes: '7 different question types',
      mobileCompatible: 'Mobile and tablet compatible',
      musicOn: 'Music ON',
      players: 'players'
    },
    giftFeatures: {
      photoGallery: 'Photo gallery with animated slideshow',
      pdfInvites: 'Personalized PDF invitations',
      multiReservations: 'Multiple reservations per gift',
      anonymousOption: 'Anonymous option for guests',
      reservedBy: 'Reserved by',
      persons: 'people'
    },
    howItWorks: {
      step: 'Step',
      step1Title: 'Sign up',
      step1Desc: 'Create a free account in 30 seconds',
      step2Title: 'Create',
      step2Desc: 'Quiz, questionnaire or gift list',
      step3Title: 'Share',
      step3Desc: 'Send the link to your participants',
      step4Title: 'Analyze',
      step4Desc: 'View results in real time'
    },
    navbar: {
      quiz: 'Quiz',
      events: 'Events',
      gifts: 'Gifts',
      interactiveQuiz: 'Interactive Quizzes',
      liveQuiz: 'Live Quiz',
      questionnaires: 'Questionnaires',
      giftLists: 'Gift Lists',
      features: 'Features'
    },
    // Hero section
    heroTitle: 'Create memorable experiences',
    // Quiz preview mockup
    quizPreview: {
      questionNumber: 'Question 3/10',
      sampleQuestion: 'What is the capital of France?',
      option1: 'Paris',
      option2: 'London',
      option3: 'Berlin',
      option4: 'Madrid'
    },
    // Gift list preview mockup
    giftPreview: {
      weddingTitle: 'Mary & Peter\'s Wedding',
      weddingDate: 'June 15, 2025',
      item1: 'Kitchen Robot',
      item2: 'Dinnerware Set',
      item3: 'Honeymoon Trip',
      reservedBy1: 'Aunt Sophie'
    },
    // Guest list preview mockup
    guestListPreview: {
      guest1: 'Mary Smith',
      guest2: 'Peter Johnson',
      guest3: 'Sophie Williams'
    },
    // Guestbook preview mockup
    guestbookPreview: {
      author1: 'Grandma Jane',
      message1: 'Congratulations my dears! 💕',
      author2: 'Thomas & Lea',
      message2: 'A magical evening, thank you!',
      author3: 'Uncle John',
      message3: 'Long live the newlyweds! 🥂'
    },
    // Guest list section
    guestList: {
      title: 'Guest List',
      persons: 'pers.',
      confirmed: 'confirmed',
      heading: 'Manage your guests',
      subheading: 'with ease',
      description: 'Track confirmations, send reminders and export your list. Everything is centralized for perfect organization.',
      feature1: 'Personalized email invitations',
      feature2: 'Real-time confirmation tracking',
      feature3: 'PDF and Excel export'
    },
    // Guestbook section
    guestbook: {
      heading: 'Digital Guestbook',
      subheading: 'Memories forever',
      description: 'Your guests leave their messages and photos. Create a unique memory album that you will cherish forever.',
      feature1: 'Text and audio messages',
      feature2: 'Guest photos and videos',
      feature3: 'Customizable design',
      bookTitle: 'Guestbook'
    },
    // Seating plan section
    seating: {
      heading: 'Interactive Seating Plan',
      subheading: 'with table placement',
      description: 'Create your seating plan with drag-and-drop. Assign your guests to tables and visualize the result in real time.',
      feature1: 'Intuitive drag-and-drop interface',
      feature2: 'Automatic seat assignment',
      feature3: 'Export and print the plan',
      preview: 'Seating Plan',
      tables: 'tables',
      seats: 'seats',
      dragDrop: 'Drag-and-drop'
    },
    // Pro section
    pro: {
      badge: 'Pro Plan',
      heading: 'Take it to the next level',
      description: 'Unlock all features and enjoy unlimited participants for your quizzes and events.',
      feature1Title: 'Unlimited participants',
      feature1Desc: 'No more 5 player limit',
      feature2Title: 'Questionnaires',
      feature2Desc: 'Create complete surveys',
      feature3Title: 'Events',
      feature3Desc: 'Gift lists, guests, seating plan',
      price: 'Starting at €5',
      period: '/month',
      cta: 'View plans'
    }
  },
  
  // Footer
  footer: {
    description: 'The interactive platform for creating quizzes, questionnaires and managing your events.',
    support: 'Support',
    legal: 'Legal',
    terms: 'Terms of Use',
    privacy: 'Data Protection',
    help: 'Help',
    rights: 'All rights reserved.'
  },

  // Help
  help: {
    hero: {
      title: 'HugoQuiz Help Center',
      subtitle: 'Discover all the features of HugoQuiz and learn how to use them effectively to create memorable events.'
    },
    tabs: {
      faq: 'Frequently Asked Questions',
      docs: 'Complete Documentation'
    },
    tips: {
      title: 'Tips to Get Started',
      tip1: 'Start by creating a simple event to familiarize yourself with the interface.',
      tip2: 'Use quiz templates to save time when creating.',
      tip3: 'Always test your quiz in preview mode before sharing.',
      tip4: 'Check the statistics after each event to improve.'
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: {
        question: 'How do I create my first event?',
        answer: 'To create your first event, log in to your HugoQuiz account, then click "Create an event" from your dashboard. Fill in the basic information (name, date, location, description) and customize the options according to your needs. You can then add guests, create a program, manage tables and much more.'
      },
      q2: {
        question: 'What is the difference between a live quiz and an asynchronous quiz?',
        answer: 'A live quiz is played in real-time with all participants connected simultaneously. The host controls the pace and displays questions one by one. Perfect for parties, weddings, or team buildings.\n\nAn asynchronous quiz allows participants to play at their own pace, whenever they want. Everyone answers questions individually and results are compiled automatically. Perfect for training or surveys.'
      },
      q3: {
        question: 'How do I invite participants to my event?',
        answer: 'You can invite participants in several ways:\n• Manually add their contact details to the guest list\n• Import an Excel/CSV file with the guest list\n• Share an invitation link or QR code\n• Send email invitations directly from HugoQuiz\n\nEach guest will receive personalized access with a unique QR code for the event day.'
      },
      q4: {
        question: 'How does the table and seating plan system work?',
        answer: 'The table management system allows you to:\n• Create different table types (round, rectangular, square)\n• Define the number of seats per table\n• Drag and drop guests to tables\n• View the seating plan in real-time\n• Print personalized place cards and the complete plan\n\nThe interactive seating plan helps you optimize the layout and manage guest affinities.'
      },
      q5: {
        question: 'Can I customize the appearance of my quizzes?',
        answer: 'Yes, HugoQuiz offers many customization options:\n• Choose from several visual themes\n• Add your logo and images\n• Customize the main colors\n• Add background music\n• Configure time per question\n• Customize end messages\n\nThis allows you to create an experience consistent with your event identity.'
      },
      q6: {
        question: 'How does the digital guestbook work?',
        answer: 'The digital guestbook allows your guests to leave messages, photos, and videos during or after the event. They can:\n• Write personalized messages\n• Add photos or selfies\n• Record voice messages\n• React to others\' messages\n\nAll memories are preserved and you can export them as a PDF or photo album.'
      },
      q7: {
        question: 'How do I scan tickets/QR codes on event day?',
        answer: 'On event day, use the "Scan QR" function from your dashboard:\n• Allow camera access on your device\n• Scan each guest\'s QR code\n• The system instantly confirms validity\n• The guest is automatically marked as "arrived"\n• You see attendance rate in real-time\n\nYou can use multiple devices simultaneously to speed up check-in.'
      },
      q8: {
        question: 'How do I create conditional questions in a questionnaire?',
        answer: 'Conditional questions allow you to display certain questions based on previous answers. To configure them:\n1. Create your main question\n2. Enable the "Conditional question" option\n3. Define the condition (e.g., "If answer = Yes")\n4. Select the question to display if the condition is met\n\nPerfect for RSVPs (asking dietary restrictions only if the person confirms attendance).'
      },
      q9: {
        question: 'How does the subscription work and can I change plans?',
        answer: 'HugoQuiz offers several plans adapted to your needs:\n• Free: basic features, perfect for discovering\n• Premium: advanced features for individuals\n• Business: all features + priority support\n\nYou can change plans at any time. The change takes effect immediately and the amount is calculated pro rata.'
      },
      q10: {
        question: 'Is my data secure?',
        answer: 'Data security is our priority:\n• Hosted on secure European servers\n• SSL/TLS encryption for all communications\n• Full GDPR compliance\n• Daily automatic backups\n• Secure authentication\n• Delete your data at any time\n\nYou remain the owner of your data and can export it whenever you want.'
      },
      q11: {
        question: 'How do I add music to my quiz?',
        answer: 'To add music to your quiz:\n1. Access quiz settings\n2. "Music and sounds" section\n3. Upload your audio files (MP3, WAV)\n4. Configure music for each phase:\n   • Waiting for players\n   • During questions\n   • Correct/incorrect answer\n   • Final podium\n\nYou can also use the built-in royalty-free music library.'
      },
      q12: {
        question: 'How do I view my event statistics?',
        answer: 'Complete statistics are accessible from each event page:\n• RSVP response rate with time evolution\n• Attendance statistics on the day\n• Detailed quiz statistics (scores, response times)\n• Attendance rate on D-Day\n• Guestbook messages\n• Charts and trends\n\nYou can export these statistics as PDF or Excel for your archives.'
      },
      q13: {
        question: 'Can I use HugoQuiz on mobile?',
        answer: 'Yes, HugoQuiz is fully responsive and works perfectly on:\n• Smartphones (iOS and Android)\n• Tablets\n• Computers\n\nParticipants can play quizzes and access features from any device with a modern web browser. No app to install!'
      },
      q14: {
        question: 'How do I contact support if I have a problem?',
        answer: 'Several options to contact us:\n• Live chat (icon at bottom right)\n• Email: contact@hugoquiz.com\n• Online documentation and tutorials\n\nOur team usually responds within 24 hours on business days. Premium and Business subscribers get priority support.'
      },
      q15: {
        question: 'Can I try HugoQuiz for free before subscribing?',
        answer: 'Absolutely! HugoQuiz offers:\n• A permanent free plan with essential features\n• A 7-day free trial for paid plans\n• No credit card required for the free plan\n\nThe 7-day trial gives you access to ALL premium features. You can cancel at any time without charge during the trial period.'
      }
    },
    docs: {
      events: {
        title: 'Event Management',
        description: 'Create and manage complete events with all the necessary features.',
        guests: {
          title: 'Guest List',
          content: 'Manage your guest list efficiently:\n\n• Add guests manually or import from Excel/CSV\n• Track attendance confirmations (RSVP) in real-time\n• Send email invitations with personalized QR code\n• Manage companions and children\n• Categorize your guests (family, friends, colleagues)\n• Export the complete list at any time\n• Track dietary restrictions and allergies'
        },
        gifts: {
          title: 'Gift Registry',
          content: 'Create a collaborative gift list:\n\n• Add gift ideas with photos and links\n• Guests can reserve a gift (visible only to them)\n• Avoid duplicates with the reservation system\n• Set priorities and categories\n• Add contribution pools for big gifts\n• Receive notifications when a gift is reserved\n• Easily send thanks with integrated tracking'
        },
        tables: {
          title: 'Table Management',
          content: 'Organize your reception perfectly:\n\n• Create different table types (round, rectangular, cocktail)\n• Define the number of seats per table\n• Name your tables (numbers, flower names, cities...)\n• Assign guests by drag and drop\n• View remaining seats\n• Print personalized place cards\n• Easily manage last-minute changes'
        },
        qrcode: {
          title: 'QR Scanner & Check-in',
          content: 'Simplify guest check-in:\n\n• Each guest receives a unique QR code\n• Quickly scan with any smartphone\n• Immediate visual and audio confirmation\n• Real-time arrival tracking\n• Detection of invalid or already scanned QR codes\n• Live attendance statistics\n• Multiple check-in stations possible'
        },
        seating: {
          title: 'Interactive Seating Plan',
          content: 'Visualize and optimize your space:\n\n• Intuitive drag & drop editor\n• Position tables, stage, dance floor, buffet\n• Add decorative elements (entrance, bar, photo booth)\n• Freely resize and orient elements\n• Automatic save of changes\n• Overview for large spaces\n• Export and print final plan'
        },
        guestbook: {
          title: 'Digital Guestbook',
          content: 'Collect precious memories:\n\n• Elegant interface for messages\n• Photo and selfie uploads by guests\n• Optional voice or video messages\n• Content moderation if needed\n• Reactions and likes on messages\n• PDF export in keepsake album format\n• Accessible before, during and after the event'
        },
        stats: {
          title: 'Detailed Statistics',
          content: 'Analyze your event in depth:\n\n• RSVP response rate with time evolution\n• Attendance statistics on the day\n• Questionnaire and quiz analysis\n• Guestbook engagement\n• Visual and exportable charts\n• Comparison with your previous events\n• Key performance indicators (KPIs)'
        },
        planning: {
          title: 'Planning & Timeline',
          content: 'Organize every detail of your event:\n\n• Create a detailed timeline\n• Set milestones and deadlines\n• Assign managers for each task\n• Calendar or list view as preferred\n• Automatic email reminders\n• Track overall progress\n• Share with your vendors'
        },
        program: {
          title: 'Event Program',
          content: 'Communicate the schedule to your guests:\n\n• Create a detailed hourly program\n• Add icons and descriptions\n• Define locations for each activity\n• Program accessible via invitation\n• Real-time updates if changes\n• Optional push notifications\n• Printable version available'
        },
        menu: {
          title: 'Menu & Carte',
          content: 'Present your menu elegantly:\n\n• Create multiple menus (adults, children, vegetarian)\n• Add starters, mains, desserts, drinks\n• Indicate allergens and origins\n• Include dish photos\n• Menu viewable by guests\n• Link choices to RSVP questionnaire\n• PDF export for printing'
        },
        tasks: {
          title: 'Task Management',
          content: 'Don\'t forget anything for the big day:\n\n• Create task lists by category\n• Assign managers\n• Set deadlines\n• Track progress by percentage\n• Receive automatic reminders\n• Check off completed tasks\n• Collaborate with your organizing team'
        }
      },
      quiz: {
        title: 'Interactive Quizzes',
        description: 'Animate your events with fun and engaging quizzes.',
        create: {
          title: 'Quiz Creation',
          content: 'Create captivating quizzes in minutes:\n\n• Intuitive creation interface\n• Multiple choice, true/false, free text questions\n• Add images and media to questions\n• Set response time per question\n• Configure points based on difficulty\n• Preview before publishing\n• Duplicate and modify existing quizzes'
        },
        live: {
          title: 'Live Mode (Real-time)',
          content: 'Host a live quiz like a pro:\n\n• Waiting room with ambient music\n• Players join via code or QR code\n• You control the question pace\n• Synchronized display on all screens\n• Real-time leaderboard between questions\n• Participant reactions and emojis\n• Animated podium with music at the end\n• Perfect for weddings, team buildings, parties'
        },
        async: {
          title: 'Asynchronous Mode',
          content: 'Let players participate at their own pace:\n\n• Share a unique link\n• Everyone plays when they want\n• Limited or unlimited time per question\n• Scores accumulate automatically\n• Leaderboard updated continuously\n• Ideal for training, review, surveys\n• Results viewable anytime'
        },
        leaderboard: {
          title: 'Leaderboard & Podium',
          content: 'Celebrate winners in style:\n\n• Real-time leaderboard during quiz\n• Animated podium with visual effects\n• Customizable victory music\n• Display scores and response times\n• Export complete leaderboard\n• Optional participation certificates\n• Social media sharing'
        },
        stats: {
          title: 'Quiz Statistics',
          content: 'Analyze performance in detail:\n\n• Correct answer rate per question\n• Average response time\n• Most difficult questions\n• Score evolution\n• Session comparison\n• Identify areas for improvement\n• Export data for deep analysis'
        },
        music: {
          title: 'Music & Sounds',
          content: 'Create an immersive atmosphere:\n\n• Waiting room music\n• Countdown sounds\n• Right/wrong answer jingle\n• Suspense music between questions\n• Fanfare for the podium\n• Built-in royalty-free music library\n• Upload your own music'
        },
        media: {
          title: 'Images & Media',
          content: 'Visually enrich your questions:\n\n• Add images to questions\n• Embed YouTube videos\n• "Guess the image" questions\n• Reusable media gallery\n• Automatic image optimization\n• Support for common formats (JPG, PNG, GIF)\n• Storage included with your plan'
        },
        settings: {
          title: 'Advanced Settings',
          content: 'Customize every aspect of the quiz:\n\n• Maximum number of participants\n• Allow latecomers or not\n• Shuffle question order\n• Shuffle answer order\n• Show or hide intermediate scores\n• Dark or light mode\n• Color customization'
        }
      },
      questionnaire: {
        title: 'Smart Questionnaires',
        description: 'Collect precise information with flexible forms.',
        create: {
          title: 'Questionnaire Creation',
          content: 'Design professional questionnaires:\n\n• Intuitive visual editor\n• Drag and drop to reorganize\n• Multiple sections and pages\n• Custom description and instructions\n• Real-time preview\n• Duplicate existing questionnaires\n• Ready-to-use templates (RSVP, satisfaction...)'
        },
        conditional: {
          title: 'Conditional Questions',
          content: 'Create intelligent, personalized paths:\n\n• Display questions based on previous answers\n• Example: "How many companions?" only if "Will you come? = Yes"\n• Multiple conditions (AND/OR)\n• Skip entire sections\n• Different paths based on profile\n• Logic visible in editor\n• Easily test different scenarios'
        },
        types: {
          title: 'Question Types',
          content: 'Choose the format adapted to each need:\n\n• Single choice (radio)\n• Multiple choice (checkboxes)\n• Short or long text\n• Email, phone with validation\n• Date and time\n• Rating scale (1-5, 1-10)\n• File upload\n• Ranking by preference order'
        },
        results: {
          title: 'Results & Analysis',
          content: 'Use responses effectively:\n\n• Statistics overview\n• Charts per question\n• Complete Excel/CSV export\n• Filter by criteria\n• Detailed individual responses\n• Time evolution of responses\n• Automatic email reports'
        },
        customization: {
          title: 'Customization',
          content: 'Adapt the questionnaire to your brand:\n\n• Custom logo and colors\n• Personalized welcome message\n• Custom confirmation page\n• Redirect after submission\n• Limit number of responses\n• Automatic closing date\n• Optional password access'
        }
      },
      account: {
        title: 'My Account',
        description: 'Manage your profile, subscription and preferences.',
        subscription: {
          title: 'Subscription & Billing',
          content: 'Easily manage your subscription:\n\n• View current plan and its limits\n• Change plan at any time\n• Invoice history\n• Update payment information\n• Cancellation with refund within 30 min\n• 7-day free trial available\n• Priority support depending on plan'
        },
        security: {
          title: 'Account Security',
          content: 'Effectively protect your account:\n\n• Password change\n• Login history\n• Log out from all devices\n• Delete account and data\n• GDPR compliance guaranteed\n• Export all your data\n• Two-factor verification (coming soon)'
        },
        notifications: {
          title: 'Notifications',
          content: 'Stay informed without being overwhelmed:\n\n• Customizable email notifications\n• Alerts for new responses\n• Upcoming event reminders\n• Task notifications\n• Optional weekly summary\n• In-app notification center\n• Selective disabling possible'
        },
        support: {
          title: 'Support & Assistance',
          content: 'We\'re here to help:\n\n• Live chat with our team\n• Email support within 24h\n• Complete online documentation\n• Step-by-step video tutorials\n• Regularly updated FAQ\n• Priority support for Premium\n• Personalized Business support'
        }
      }
    },
    contact: {
      title: 'Need more help?',
      description: 'Our team is available to answer all your questions and help you use HugoQuiz.',
      email: 'Contact us by email'
    }
  },

  // Privacy Policy Page
  privacy: {
    title: 'Personal Data Protection',
    lastUpdated: 'Last updated',
    lastUpdatedDate: 'January 10, 2026',
    intro: {
      title: 'Our commitment to your privacy',
      description: 'At HugoQuiz, protecting your personal data is our priority. We are committed to treating your information with the utmost care, in compliance with the General Data Protection Regulation (GDPR) and applicable laws in the European Union.'
    },
    section1: {
      title: '1. Data Controller',
      description: 'The data controller for personal data collected on the HugoQuiz platform is:',
      website: 'Website'
    },
    section2: {
      title: '2. Personal Data Collected',
      description: 'We collect the following data as part of using our platform:',
      purpose: 'Purpose',
      legalBasis: 'Legal basis',
      retention: 'Retention period',
      security: 'Security',
      email: {
        title: 'Email address',
        purpose: 'Account creation, authentication, sending notifications about your account and subscriptions.',
        legalBasis: 'Contract performance (Article 6.1.b GDPR)',
        retention: 'For the duration of your account, then 3 years after deletion for legal obligations.'
      },
      username: {
        title: 'Username / Pseudonym',
        purpose: 'Personalizing your experience, display in quizzes and events you create.',
        legalBasis: 'Contract performance (Article 6.1.b GDPR)',
        retention: 'For the duration of your account.'
      },
      password: {
        title: 'Password',
        purpose: 'Securing access to your account.',
        legalBasis: 'Contract performance (Article 6.1.b GDPR)',
        security: 'Your password is encrypted (hashed) and never stored in plain text. We have no access to your password.',
        retention: 'For the duration of your account.'
      },
      payment: {
        title: 'Payment data',
        purpose: 'Processing payments for subscriptions.',
        legalBasis: 'Contract performance (Article 6.1.b GDPR)',
        security: 'We NEVER store your banking data. All payments are processed by Stripe, a PCI-DSS Level 1 certified provider (the highest security level).',
        stripeData: 'Data transmitted to Stripe',
        stripeDataDesc: 'Only your email to associate the payment with your account.'
      },
      connection: {
        title: 'Connection and usage data',
        dataCollected: 'Data collected',
        dataCollectedDesc: 'IP address, browser type, pages visited, connection date and time.',
        purpose: 'Platform security, service improvement, anonymized statistics.',
        legalBasis: 'Legitimate interest (Article 6.1.f GDPR)',
        retention: 'Maximum 12 months.'
      },
      content: {
        title: 'Created content (Quizzes, Questionnaires, Events)',
        purpose: 'Service provision, saving your creations.',
        legalBasis: 'Contract performance (Article 6.1.b GDPR)',
        retention: 'For the duration of your subscription. In case of non-renewal of a paid subscription, data is kept for 30 days before permanent deletion.'
      }
    },
    section3: {
      title: '3. Your Rights Over Your Data',
      description: 'In accordance with the GDPR, you have the following rights:',
      access: {
        title: 'Right of access',
        description: 'Obtain confirmation that your data is being processed and receive a copy.'
      },
      rectification: {
        title: 'Right to rectification',
        description: 'Request correction of inaccurate or incomplete data.'
      },
      erasure: {
        title: 'Right to erasure',
        description: 'Request deletion of your data under the conditions provided by the GDPR.'
      },
      restriction: {
        title: 'Right to restriction',
        description: 'Request restriction of the processing of your data.'
      },
      portability: {
        title: 'Right to portability',
        description: 'Receive your data in a structured and commonly used format.'
      },
      objection: {
        title: 'Right to object',
        description: 'Object to the processing of your data for legitimate reasons.'
      },
      contact: 'To exercise these rights, contact us at'
    },
    section4: {
      title: '4. Data Security',
      description: 'We implement appropriate technical and organizational measures to protect your data:',
      https: 'HTTPS/TLS Encryption',
      httpsDesc: 'All communications are encrypted.',
      hosting: 'Secure hosting',
      hostingDesc: 'Data hosted on Firebase (Google Cloud) servers certified ISO 27001.',
      passwords: 'Encrypted passwords',
      passwordsDesc: 'Using secure hashing algorithms.',
      accessControl: 'Restricted access',
      accessControlDesc: 'Only authorized personnel have access to data.'
    },
    section5: {
      title: '5. Data Transfers',
      description: 'Your data may be processed by the following subcontractors, all GDPR compliant:',
      subcontractor: 'Subcontractor',
      purposeCol: 'Purpose',
      location: 'Location',
      firebase: 'Hosting, database',
      firebaseLocation: 'EU (europe-west)',
      stripe: 'Payments',
      stripeLocation: 'EU / USA (SCC)',
      brevo: 'Email sending',
      brevoLocation: 'France'
    },
    section6: {
      title: '6. Cookies',
      description: 'Our platform uses only essential technical cookies for service operation:',
      authCookie: 'Authentication cookie',
      authCookieDesc: 'Maintaining your login session.',
      preferences: 'Preferences',
      preferencesDesc: 'Selected language.',
      noTracking: 'We do not use advertising cookies or third-party tracking cookies.'
    },
    section7: {
      title: '7. Retention Period',
      description: 'Your data is retained according to the following periods:',
      dataType: 'Data type',
      retentionPeriod: 'Retention period',
      accountData: 'Account data (email, name)',
      accountDataRetention: 'Account duration + 3 years',
      createdContent: 'Created content (quizzes, events)',
      createdContentRetention: 'Subscription duration + 30 days',
      paymentData: 'Payment data',
      paymentDataRetention: '10 years (legal accounting requirement)',
      connectionLogs: 'Connection logs',
      connectionLogsRetention: '12 months'
    },
    section8: {
      title: '8. Contact and Complaints',
      description: 'For any questions regarding the protection of your data or to exercise your rights, you can contact us at:',
      complaint: 'If you believe your rights are not being respected, you can file a complaint with the CNIL (French Data Protection Authority):'
    }
  },

  // Terms of Use Page (CGU)
  cgu: {
    title: 'Terms of Use',
    lastUpdated: 'Last updated',
    lastUpdatedDate: 'January 10, 2026',
    article1: {
      title: 'ARTICLE 1 – PURPOSE AND SCOPE',
      p1: '1.1. These Terms of Use (hereinafter referred to as "Terms") define the terms and conditions under which HugoQuiz (hereinafter referred to as "the Publisher") makes available to its users (hereinafter referred to as "the User" or "Users") the platform accessible at https://hugoquiz.com (hereinafter referred to as "the Platform").',
      p2: '1.2. Access and use of the Platform are subject to unconditional acceptance of these Terms. The User acknowledges having read these Terms prior to any use of the Platform and agrees to comply with them without restriction or reservation.',
      p3: '1.3. These Terms apply to all Users of the Platform, whether they hold a free account or a paid subscription.'
    },
    article2: {
      title: 'ARTICLE 2 – DEFINITIONS',
      subscription: 'Subscription',
      subscriptionDef: 'refers to the User\'s subscription to one of the paid plans offered by the Publisher, granting access to extended features of the Platform.',
      userAccount: 'User Account',
      userAccountDef: 'refers to the User\'s personal space, accessible by means of login credentials, allowing access to the Services.',
      services: 'Services',
      servicesDef: 'refers to all features and services offered by the Platform, including the creation of quizzes, questionnaires and event management.',
      subscriptionPeriod: 'Subscription Period',
      subscriptionPeriodDef: 'refers to the duration during which the User benefits from the Services associated with their Subscription, starting from the subscription date.'
    },
    article3: {
      title: 'ARTICLE 3 – REGISTRATION AND USER ACCOUNT',
      p1: '3.1. Access to certain features of the Platform requires prior creation of a User Account. Registration is free and is done by completing the registration form available on the Platform.',
      p2: '3.2. The User agrees to provide accurate, current and complete information during registration. They also agree to update this information if it changes.',
      p3: '3.3. The User is solely responsible for the confidentiality of their login credentials and all activities performed from their User Account.'
    },
    article4: {
      title: 'ARTICLE 4 – SUBSCRIPTIONS AND PRICING CONDITIONS',
      p1: '4.1. The Platform offers different Subscription plans, the features and prices of which are specified on the pricing page. Prices are indicated in euros, including all taxes.',
      p2: '4.2. Payment for the Subscription is made by credit card via the secure payment platform Stripe. The Subscription takes effect immediately after payment validation.',
      p3: '4.3. Unless terminated under the conditions set out in Article 5, the Subscription is automatically renewed for a period identical to the initial Subscription Period. The Subscription amount is automatically debited on each anniversary date of subscription.'
    },
    article4bis: {
      title: 'ARTICLE 4 BIS – FREE TRIAL',
      section1Title: '4 bis.1. FREE TRIAL CONDITIONS',
      section1Desc: 'The Publisher offers new Users the opportunity to benefit from a free trial period of SEVEN (7) DAYS for any monthly Subscription. This offer is subject to the following conditions:',
      section1Item1: 'The free trial is only available ONCE per User, regardless of the plan chosen;',
      section1Item2: 'If the User activates a free trial on one plan, they permanently lose the right to a free trial on all other plans;',
      section1Item3: 'Registration of a payment method (credit card) is mandatory to activate the free trial;',
      section1Item4: 'Users who have received complimentary premium access from the administrator cannot benefit from the free trial.',
      section2Title: '4 bis.2. DURATION AND OPERATION',
      section2Desc: 'During the seven (7) day trial period:',
      section2Item1: 'The User benefits from all features of the chosen plan;',
      section2Item2: 'No payment is debited during the trial period;',
      section2Item3: 'The User may cancel at any time before the end of the trial period at no cost.',
      section3Title: '4 bis.3. END OF TRIAL PERIOD',
      section3Desc: 'At the end of the seven (7) day trial period:',
      section3Item1: 'The first payment will be automatically debited at 00:00 (Paris time) on the eighth (8th) day following trial activation;',
      section3Item2: 'The Subscription will then be automatically renewed according to the conditions set out in Article 4.3;',
      section3Item3: 'The User will be notified by email before the end of the trial period.',
      section4Title: '4 bis.4. CANCELLATION DURING TRIAL',
      section4Desc: 'The User may cancel their free trial at any time during the seven (7) days via their personal space. In case of cancellation during the trial period:',
      section4Item1: 'No payment will be debited;',
      section4Item2: 'Access to premium features will end immediately;',
      section4Item3: 'The User will no longer be able to benefit from a new free trial, even on another plan.',
      section5Title: '4 bis.5. ABUSE PROTECTION',
      section5Desc: 'To prevent any abuse, the Publisher implements the following protection measures:',
      section5Item1: 'Eligibility for the free trial is verified server-side and cannot be bypassed;',
      section5Item2: 'Cancelling the free trial does not allow activation of a new one;',
      section5Item3: 'The Publisher reserves the right to refuse or cancel a free trial in case of suspected fraud.'
    },
    article5: {
      title: 'ARTICLE 5 – RIGHT OF WITHDRAWAL, TERMINATION AND REFUND',
      section1Title: '5.1. LIMITED RIGHT OF WITHDRAWAL',
      section1Desc: 'In accordance with Article L.221-28 of the French Consumer Code, and given the nature of the Services offered (digital content not supplied on a tangible medium whose execution has begun with the prior express consent of the consumer), the User has a limited right of withdrawal under the following conditions:',
      section1Important: 'A full refund of the Subscription is only possible if the cancellation request is made within THIRTY (30) MINUTES of the initial Subscription. After this period, no refund will be granted for the current Subscription Period.',
      section2Title: '5.2. RENEWAL TERMINATION',
      section2Desc: 'The User may decide at any time, without any time restriction, not to renew their Subscription from their personal space:',
      section2Important: 'Cancellation of automatic renewal is possible AT ANY TIME, including in the hours preceding the renewal date. Once cancellation is completed, no further payment will be made and the User retains access to the Services until the end of the current Subscription Period. No refund is made.',
      section3Title: '5.3. NO REFUND',
      section3Desc: 'The User retains the right to terminate their Subscription at any time. However, if termination occurs:',
      section3Item1: 'More than thirty (30) minutes after the initial subscription; or',
      section3Item2: 'After the start of an already-paid Subscription Period; or',
      section3Item3: 'After an automatic renewal of the Subscription',
      section3NoRefund: 'No refund, even partial or pro rata, will be granted.',
      section4Title: '5.4. IMPORTANT CLARIFICATIONS',
      section4Desc: 'The thirty (30) minute right of withdrawal with refund applies exclusively to the initial subscription and does not apply to subsequent automatic renewals.',
      section5Title: '5.5. IMMEDIATE PLAN TERMINATION',
      section5Desc: 'The User may, at any time and without restriction, immediately terminate their plan from their personal space. In this case:',
      section5Item1: 'The loss of plan benefits and features is IMMEDIATE;',
      section5Item2: 'No refund, even partial, is possible;',
      section5Item3: 'The User immediately returns to the free plan and receives an email confirmation.'
    },
    article6: {
      title: 'ARTICLE 6 – USER OBLIGATIONS',
      p1: '6.1. The User agrees to use the Platform in accordance with its intended purpose and in compliance with applicable laws and regulations.',
      p2: '6.2. The User is prohibited from:',
      item1: 'Using the Platform for illegal, fraudulent purposes or infringing on the rights of third parties;',
      item2: 'Attempting to access the Publisher\'s computer systems without authorization;',
      item3: 'Distributing illegal, defamatory, insulting or public order-contrary content;',
      item4: 'Reproducing, copying or commercially exploiting all or part of the Platform without prior authorization.',
      p3: '6.3. The User agrees to comply with the storage usage quotas defined in Article 6 bis.'
    },
    article6bis: {
      title: 'ARTICLE 6 BIS – STORAGE QUOTA',
      p1: '6 bis.1. Each User has a personal storage space limited to two gigabytes (2 GB) for all files uploaded to the Platform (images, photos, documents, multimedia content, etc.). This quota applies cumulatively to all Services used (Quizzes, Questionnaires, Events).',
      p2: '6 bis.2. The User is required to monitor their storage usage via the dedicated interface in their account settings. A consumption indicator is available at all times.',
      p3: '6 bis.3. When the User reaches ninety percent (90%) of their storage quota, a warning notification will be sent. When the quota of two gigabytes (2 GB) is reached, the User will no longer be able to upload new files until they free up space or obtain a quota extension.',
      p4: '6 bis.4. Extending the storage quota beyond the two gigabyte (2 GB) limit is at the sole discretion of the Publisher. The User may submit a written extension request to',
      p4b: 'The Publisher reserves the right to grant or refuse any extension request, with or without justification.',
      p5: '6 bis.5. The Publisher reserves the right to delete, after thirty (30) days prior notification, files from accounts inactive for more than twelve (12) consecutive months, to ensure optimal use of storage resources.'
    },
    article7: {
      title: 'ARTICLE 7 – INTELLECTUAL PROPERTY',
      p1: '7.1. All elements constituting the Platform (texts, graphics, software, photographs, images, videos, sounds, plans, names, logos, trademarks, creations and various protectable works, databases, etc.) as well as the Platform itself are the exclusive property of the Publisher or its partners.',
      p2: '7.2. These elements are protected by intellectual property laws and in particular copyright. Any reproduction, representation, use or adaptation, in any form whatsoever, of all or part of these elements, without the prior written consent of the Publisher, is strictly prohibited.'
    },
    article8: {
      title: 'ARTICLE 8 – LIMITATION OF LIABILITY',
      p1: '8.1. The Publisher undertakes to implement all necessary means to ensure the continuity and quality of the Services. However, the Publisher cannot be held responsible for temporary interruptions of the Platform for technical reasons, maintenance or in case of force majeure.',
      p2: '8.2. The Publisher cannot be held responsible for direct or indirect damages resulting from the User\'s use of the Platform, in particular in case of data loss, business interruption or any other damage.'
    },
    article9: {
      title: 'ARTICLE 9 – PERSONAL DATA PROTECTION',
      p1: '9.1. The Publisher undertakes to respect Users\' privacy and to process personal data in accordance with Regulation (EU) 2016/679 of the European Parliament and of the Council of April 27, 2016 (General Data Protection Regulation - GDPR).',
      p2: '9.2. The methods of collection, processing and protection of personal data are detailed in the Data Protection Policy, accessible from the Platform.'
    },
    article10: {
      title: 'ARTICLE 10 – MODIFICATION OF TERMS',
      p1: '10.1. The Publisher reserves the right to modify these Terms at any time. Modifications take effect upon publication on the Platform.',
      p2: '10.2. The User will be informed of any substantial modification of the Terms by any appropriate means. Continued use of the Platform after notification of modifications constitutes acceptance of the new Terms.'
    },
    article10bis: {
      title: 'ARTICLE 10 BIS – ACCOUNT DELETION',
      section1Title: '10 bis.1. RIGHT TO DELETION',
      section1Desc: 'The User has the right at any time to request deletion of their User Account. This request can be made directly from the "Profile" page of the Platform by clicking on the "Delete my account" button.',
      section2Title: '10 bis.2. EFFECTS OF DELETION',
      section2Warning: 'Account deletion is IRREVERSIBLE. Once confirmed, deletion results in:',
      section2Item1: 'Permanent deletion of all quizzes created by the User;',
      section2Item2: 'Permanent deletion of all questionnaires created by the User;',
      section2Item3: 'Permanent deletion of all events and their associated data (guests, seating plan, guestbook);',
      section2Item4: 'Permanent deletion of the User\'s personal data;',
      section2Item5: 'Inability to recover the account or deleted data.',
      section3Title: '10 bis.3. FREE ACCOUNTS',
      section3Desc: 'For Users with a free account, deletion is effective immediately after confirmation.',
      section4Title: '10 bis.4. ACCOUNTS WITH PAID SUBSCRIPTION',
      section4Warning: 'IMPORTANT WARNING: If the User has a paid Subscription through Stripe and automatic renewal is scheduled within LESS THAN FORTY-EIGHT (48) HOURS, and the User has not previously cancelled this renewal:',
      section4Item1: 'The Subscription amount for the following period WILL BE CHARGED despite the deletion request;',
      section4Item2: 'No refund will be granted for this charge;',
      section4Item3: 'The account will nevertheless be marked as deleted and the User will no longer have access to the Platform;',
      section4Item4: 'Permanent data deletion will occur after payment processing.',
      section5Title: '10 bis.5. RECOMMENDATION',
      section5Desc: 'It is strongly recommended that Users wishing to delete their account:',
      section5Item1: 'First cancel their Subscription renewal (at least 48 hours before the renewal date);',
      section5Item2: 'Wait for the end of the current Subscription period;',
      section5Item3: 'Then proceed with account deletion.',
      section6Title: '10 bis.6. ACCOUNTS WITH ADMINISTRATOR-GRANTED ACCESS',
      section6Desc: 'For Users benefiting from premium access granted free of charge by the administrator, account deletion is effective immediately after confirmation, without any charge.'
    },
    article11: {
      title: 'ARTICLE 11 – APPLICABLE LAW AND JURISDICTION',
      p1: '11.1. These Terms are governed by French law and European Union law.',
      p2: '11.2. In case of dispute relating to the interpretation, execution or termination of these Terms, and failing amicable resolution, the French courts shall have sole jurisdiction.',
      p3: '11.3. In accordance with the Consumer Code provisions concerning amicable dispute resolution, the User may use the mediation service offered by the Publisher. The mediator can be contacted at: contact@hugoquiz.com'
    },
    article12: {
      title: 'ARTICLE 12 – CONTACT',
      desc: 'For any questions regarding these Terms or the Services, the User may contact the Publisher at:'
    },
    servicesSection: {
      title: 'Article 10 ter - "Services" marketplace',
      purposeTitle: 'Purpose',
      purpose: "HugoQuiz provides a marketplace that lets users (the \"Providers\") offer their services to other users or visitors. HugoQuiz acts solely as a technical intermediary host and is not a party to the contracts concluded between Providers and clients. Browsing services is free; creating a service requires an account and prior verification of the Provider's identity.",
      verificationTitle: 'Identity verification',
      verification: "To publish a service, the Provider must provide a valid official ID document (ID card, European Union passport, residence permit, visa or driving license) as well as a short selfie video. These are used exclusively to confirm that the declared identity matches the person. Every service is subject to review by our team before publication.",
      prohibitedTitle: 'Prohibited services',
      prohibitedIntro: 'The following are strictly prohibited and will be refused, restricted or immediately removed, without prejudice to legal action:',
      prohibited1: 'any service of a sexual, pornographic or escort nature;',
      prohibited2: 'the sale, production or distribution of drugs, narcotics or illicit substances;',
      prohibited3: 'the sale of weapons, explosives or regulated dangerous goods;',
      prohibited4: 'any service contrary to the law or illegal in the European Union or in the country of performance;',
      prohibited5: "content or activities inciting hatred, violence, discrimination or infringing the rights of others;",
      prohibited6: 'any scam, counterfeiting, money laundering or fraudulent activity.',
      responsibilityTitle: 'Provider responsibility',
      responsibility: "The Provider is solely responsible for the legality, accuracy and performance of the services they offer, as well as for compliance with their legal, tax and regulatory obligations. HugoQuiz reserves the right to moderate, restrict or remove any service, and to suspend any account, in the event of a breach of these terms, with automatic notification of the user concerned.",
      dataTitle: 'Data and contact form',
      data: "Publicly displayed contact details (email, phone) are shown at the Provider's discretion. When a visitor sends a request through a service's contact form, the information provided (name, phone, client type, subject and description of the request) is forwarded to the relevant Provider via notification and email to enable the connection. By submitting the form, the user expressly consents to this processing and transmission. Identity documents and verification videos are kept confidential and accessible only to HugoQuiz's moderation team, in accordance with the privacy policy."
    }
  },
  
  // Auth
  auth: {
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    password: 'Password',
    confirmPassword: 'Confirm password',
    displayName: 'Display name',
    displayNamePlaceholder: 'John Doe',
    firstName: 'First name',
    lastName: 'Last name',
    loginTitle: 'Login',
    registerTitle: 'Create account',
    loginButton: 'Login',
    registerButton: 'Sign up',
    forgotPassword: 'Forgot password?',
    forgotPasswordTitle: 'Forgot password',
    resetPasswordDesc: 'Enter your email to reset',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    pendingValidation: 'Account pending validation',
    pendingMessage: 'Your account is being validated by an administrator.',
    backToHome: 'Back to home',
    backToLogin: 'Back to login',
    welcomeTo: 'Welcome to',
    joinHugoQuiz: 'Join HugoQuiz',
    createAccount: 'Create my account',
    sendResetLink: 'Send reset link',
    passwordRequirements: {
      minLength: 'At least 6 characters',
      uppercase: 'One uppercase letter',
      number: 'One number'
    },
    errors: {
      fillAllFields: 'Please fill all fields',
      fillAddressFields: 'Please fill all address fields',
      passwordMin6: 'Password must be at least 6 characters',
      passwordNoMatch: 'Passwords do not match',
      userNotFound: 'No account found with this email',
      wrongPassword: 'Wrong password',
      invalidCredential: 'Invalid email or password',
      connectionError: 'Connection error',
      emailAlreadyUsed: 'This email is already in use',
      invalidEmail: 'Invalid email',
      invalidEmailFormat: 'Invalid email format',
      weakPassword: 'Password too weak',
      registerError: 'Error during registration',
      enterEmail: 'Please enter your email',
      noAccountForEmail: 'No account associated with this email',
      tooManyAttempts: 'Too many attempts. Try again later.',
      resetError: 'Error sending reset email'
    },
    success: {
      loginSuccess: 'Login successful!',
      resetEmailSent: 'Reset email sent! Check your inbox and spam folder.',
      verificationSent: 'A verification email has been sent to'
    },
    passwordMismatch: 'Passwords do not match',
    loginError: 'Invalid email or password',
    registerError: 'Error during registration',
    emailInUse: 'This email is already in use',
    invalidEmail: 'Invalid email',
    weakPassword: 'Password too weak',
    verificationSent: 'A verification email has been sent to',
    adminValidation: 'After registration, your account must be validated by an administrator before you can access the application.',
    resetPassword: 'Reset password',
    resetPasswordSent: 'Reset email sent',
    resetPasswordError: 'Error sending reset email',
    // Address fields
    address: {
      title: 'Delivery address',
      street: 'Street',
      streetNumber: 'Number',
      postalCode: 'Postal code',
      city: 'City',
      nameAtAddress: 'Name at address',
      nameAtAddressHint: 'Name that will appear on deliveries',
      postalNotRecognized: 'Postal code not recognized but accepted'
    }
  },
  
  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome',
    hello: 'Hello',
    manageContent: 'Manage your quizzes and questionnaires',
    myQuizzes: 'My Quizzes',
    myQuestionnaires: 'My Questionnaires',
    myEvents: 'My Events',
    createQuiz: 'Create a Quiz',
    createQuestionnaire: 'Create a Questionnaire',
    createEvent: 'Create an Event',
    noQuizzes: "You haven't created any quizzes yet",
    noQuestionnaires: "You haven't created any questionnaires yet",
    noEvents: "You haven't created any events yet",
    noQuizzesDesc: 'Create your first interactive quiz',
    noQuestionnairesDesc: 'Create your first questionnaire',
    noEventsDesc: 'Create your first event',
    createFirstQuiz: 'Create my first quiz',
    createFirstQuestionnaire: 'Create my first questionnaire',
    createFirstEvent: 'Create my first event',
    recentActivity: 'Recent activity',
    quickActions: 'Quick actions',
    noDescription: 'No description',
    dateNotSet: 'Date not set',
    stats: {
      quizzesCreated: 'Quizzes created',
      questionnaires: 'Questionnaires',
      events: 'Events',
      totalContent: 'Total content',
      totalQuizzes: 'Total Quizzes',
      totalQuestionnaires: 'Total Questionnaires',
      totalEvents: 'Total Events',
      totalResponses: 'Total Responses',
      totalParticipants: 'Total Participants',
      totalGuests: 'Total Guests'
    },
    storage: {
      warning: 'Storage space almost full',
      critical: 'Storage space critical!',
      exceeded: 'Storage space exhausted!',
      usageInfo: 'You are using {{used}} of {{limit}} ({{percentage}}%)',
      contactAdmin: 'Contact contact@hugoquiz.com to increase your space.'
    },
    tabs: {
      quiz: 'Quiz',
      questionnaires: 'Questionnaires',
      events: 'Events',
      services: 'Services'
    },
    actions: {
      hostLive: 'Host live',
      viewResponses: 'View responses',
      share: 'Share',
      play: 'Play',
      answer: 'Answer',
      edit: 'Edit',
      delete: 'Delete',
      manageGuests: 'Manage guests',
      statistics: 'Statistics',
      view: 'View'
    },
    actionPanel: {
      hostLive: 'Launch live',
      testQuiz: 'Test quiz',
      viewResults: 'View results',
      share: 'Share',
      edit: 'Edit',
      delete: 'Delete',
      viewResponses: 'View responses',
      test: 'Test',
      guestList: 'Guest list',
      planning: 'Planning',
      tasks: 'Tasks',
      statistics: 'Statistics',
      shareGiftList: 'Share',
      viewGiftList: 'View list'
    },
    share: {
      title: 'Share',
      whatsapp: 'Share on WhatsApp',
      email: 'Send by Email',
      copyLink: 'Copy link',
      linkCopied: 'Link copied!',
      copyError: 'Unable to copy link',
      quizMessage: 'Come play my quiz',
      questionnaireMessage: 'Answer my questionnaire',
      eventMessage: 'Check out our gift list',
      quizEmailSubject: 'Quiz invitation',
      quizEmailBody: 'Hello,\n\nI invite you to play my quiz "{title}"!\n\nClick the following link to start:\n{link}\n\nGood luck! 🎯',
      questionnaireEmailSubject: 'Questionnaire invitation',
      questionnaireEmailBody: 'Hello,\n\nI invite you to answer my questionnaire "{title}".\n\nClick the following link to participate:\n{link}\n\nThank you for your participation! 📋',
      eventEmailSubject: 'Gift list',
      eventEmailBody: 'Hello,\n\nYou are invited to check out our gift list for "{title}"!\n\nClick the following link to see the list and reserve a gift:\n{link}\n\nThank you! 🎁'
    },
    deleteModal: {
      title: 'Confirm deletion',
      message: 'Are you sure you want to delete "{title}"? This action cannot be undone.',
      cancel: 'Cancel',
      confirm: 'Delete',
      success: 'Successfully deleted',
      error: 'Error while deleting'
    },
    eventTypes: {
      mariage: 'Wedding',
      anniversaire: 'Birthday',
      naissance: 'Birth',
      bapteme: 'Baptism',
      cremaillere: 'Housewarming',
      noel: 'Christmas',
      autre: 'Other'
    },
    loading: 'Loading...',
    loadError: 'Error loading data'
  },

  // Quiz
  quiz: {
    title: 'Quiz title',
    description: 'Description',
    questions: 'Questions',
    question: 'Question',
    answers: 'Answers',
    answer: 'Answer',
    correctAnswer: 'Correct answer',
    correctAnswers: 'Correct answers',
    wrongAnswer: 'Wrong answer',
    timeLimit: 'Time limit',
    timeLimitSeconds: 'seconds',
    points: 'Points',
    point: 'Point',
    addQuestion: 'Add question',
    editQuestion: 'Edit question',
    deleteQuestion: 'Delete question',
    play: 'Play quiz',
    playLive: 'Live Quiz',
    playPractice: 'Practice mode',
    results: 'Results',
    score: 'Score',
    leaderboard: 'Leaderboard',
    yourAnswer: 'Your answer',
    correct: 'Correct',
    incorrect: 'Incorrect',
    timeUp: 'Time\'s up!',
    nextQuestion: 'Next question',
    finish: 'Finish',
    reviewMode: 'Review mode',
    showAll: 'Show all',
    wrongAnswers: 'wrong answer(s)',
    true: 'True',
    false: 'False',
    // Play mode translations
    yourName: 'Your name',
    enterNamePlaceholder: 'Enter your name...',
    prepareToPlay: 'Get ready to play!',
    loading: 'Loading quiz...',
    checkAllCorrect: 'Check all correct answers',
    validateAnswer: 'Validate my answer',
    selectAnswer: '-- Select an answer --',
    correctAnswerWas: 'The correct answer was',
    typeYourAnswer: 'Type your answer...',
    enterNumber: 'Enter a number...',
    validate: 'Validate',
    selectAtLeastOne: 'Select at least one answer',
    enterAnswer: 'Enter an answer',
    enterValidNumber: 'Enter a valid number',
    selectRating: 'Select a rating',
    puzzleReorder: 'Put in order',
    puzzleInstruction: 'Use the arrows to reorder elements',
    validateOrder: 'Validate my order',
    correctOrder: 'Correct order',
    bravo: 'Well done',
    answerDetails: 'Answer details',
    replay: 'Play again',
    questionTypes: {
      singleChoice: 'Single choice',
      singleChoiceDesc: 'One answer possible',
      multipleChoice: 'Multiple choice',
      multipleChoiceDesc: 'Multiple answers possible',
      trueFalse: 'True or False',
      trueFalseDesc: 'True or false question',
      dropdown: 'Dropdown list',
      dropdownDesc: 'Selection from a list',
      shortText: 'Short text',
      shortTextDesc: 'Free short answer',
      number: 'Numeric answer',
      numberDesc: 'A number as answer',
      rating: 'Rating',
      ratingDesc: 'Score on a scale',
      puzzle: 'Ordering',
      puzzleDesc: 'Put elements in order'
    },
    create: {
      title: 'Create a quiz',
      editTitle: 'Edit quiz',
      editSubtitle: 'Edit questions and settings',
      quizInfo: 'Quiz Information',
      quizTitle: 'Quiz title',
      quizTitlePlaceholder: 'E.g.: General knowledge quiz',
      quizDescription: 'Description (optional)',
      quizDescriptionPlaceholder: 'Describe your quiz...',
      defaultTime: 'Default time per question',
      timeSeconds: 'Time (sec)',
      isPublic: 'Public quiz',
      isPublicDesc: 'Visible to all users',
      showAnswers: 'Show answers',
      shuffle: 'Shuffle',
      addImage: 'Add image',
      questionText: 'Question text',
      questionTextPlaceholder: 'Enter your question...',
      noQuestionText: 'Question without text',
      questionImage: 'Question image',
      imageTip: 'The image will be displayed to players during the question',
      questionType: 'Question type',
      answerOptions: 'Answer options',
      answerPlaceholder: 'Answer',
      addOption: 'Add option',
      addAnswer: 'Add answer',
      addElement: 'Add element',
      markCorrect: 'Mark as correct',
      puzzleElements: 'Elements to order',
      puzzleOrderHint: 'the order shown here = the correct order',
      puzzleTip: 'Enter elements in the CORRECT ORDER. Players will see them shuffled and will have to put them back in this order.',
      acceptedAnswers: 'Accepted correct answers',
      acceptedAnswersPlaceholder: 'Enter accepted answers separated by commas...\nExample: Paris, paris, PARIS',
      acceptedAnswersTip: 'Separate different accepted spellings with commas.',
      correctNumber: 'Correct answer (exact number)',
      correctStars: 'Correct answer (number of stars)',
      questionDuration: 'Question duration',
      questionDuplicated: 'Question duplicated',
      maxOptions: 'Maximum 6 options',
      minAnswers: 'Minimum 2 options required',
      minQuestions: 'Quiz must have at least one question',
      titleRequired: 'Please enter a quiz title',
      questionTextRequired: 'Please enter the question text',
      minOptionsRequired: 'At least 2 options are required',
      selectCorrect: 'Please select at least one correct answer',
      correctAnswerRequired: 'Please enter the correct answer',
      updateSuccess: 'Quiz updated!',
      saveQuiz: 'Save quiz',
      saving: 'Saving...',
      saveSuccess: 'Quiz saved successfully',
      saveError: 'Error saving quiz'
    },
    live: {
      title: 'Live Quiz',
      host: 'Host',
      join: 'Join',
      waitingRoom: 'Waiting room',
      waitingForHost: 'Waiting for host...',
      waitingForPlayers: 'Waiting for players...',
      startQuiz: 'Start quiz',
      playersReady: 'players ready',
      enterName: 'Enter your name',
      enterNamePlaceholder: 'Your nickname',
      joinGame: 'Join game',
      shareLink: 'Share this link',
      shareCode: 'or this code',
      scanQR: 'Scan QR code',
      preparing: 'Preparing quiz...',
      getReady: 'Get ready!',
      questionOf: 'Question {{current}} of {{total}}',
      showResults: 'Show results',
      showLeaderboard: 'Show leaderboard',
      showPodium: 'Show podium',
      nextQuestionBtn: 'Next question',
      endQuiz: 'End quiz',
      stopQuiz: 'Stop quiz',
      forceStop: 'Force stop',
      quizEnded: 'Quiz ended!',
      thanks: 'Thanks for participating!',
      yourScore: 'Your score',
      yourRank: 'Your rank',
      backToHome: 'Back to home',
      noAnswer: 'No answer',
      answered: 'Answered',
      waiting: 'Waiting...',
      correctPlayers: 'correct answers',
      avgTime: 'Average time',
      fastestPlayer: 'Fastest',
      you: 'you',
      noScoresYet: 'No scores yet',
      playersCount: '{{count}} player',
      playersCount_plural: '{{count}} players',
      playersConnected: '{{count}} player connected',
      playersConnected_plural: '{{count}} players connected',
      playingAs: 'Playing as',
      youAreFirst: 'You are first!',
      hostAboutToStart: 'The host will start the quiz soon',
      orderElements: 'Order the elements correctly',
      validateOrder: 'Validate my order',
      answerCount: '{{count}} answer',
      answerCount_plural: '{{count}} answers',
      checkAllCorrect: 'Check all correct answers',
      validateAnswer: 'Validate my answer',
      typeYourAnswer: 'Type your answer...',
      enterNumber: 'Enter a number...',
      validate: 'Validate',
      answerSent: 'Answer sent!',
      waitingForTimeEnd: 'Waiting for time to end...',
      correctAnswerWas: 'The correct answer was',
      // New keys
      joinLiveQuiz: 'Join live quiz',
      chooseAvatar: 'Choose your avatar',
      randomEmoji: 'Random emoji',
      joinWaitingRoom: 'Join waiting room',
      hostMode: 'HOST MODE',
      players: 'players',
      revealAnswers: 'Reveal answers',
      answersReceived: 'answers received',
      viewFinalScores: 'View final scores',
      finalScores: 'FINAL SCORES',
      yourFinalRanking: 'Your final ranking',
      sessionNotFound: 'Game session not found',
      alreadyStarted: 'This quiz has already started',
      sessionClosed: 'The session has been closed',
      welcome: 'Welcome to the quiz!',
      joinError: 'Error joining',
      notFound: 'Quiz not found',
      notOwner: 'You are not the owner of this quiz',
      noQuestions: 'This quiz has no questions',
      loadError: 'Error loading quiz',
      startError: 'Error starting',
      nextQuestionError: 'Error going to next question',
      confirmStop: 'Are you sure you want to stop the quiz now?',
      correct: 'Correct!',
      incorrect: 'Incorrect',
      points: 'points',
      podium: {
        title: 'Podium',
        first: '1st',
        second: '2nd',
        third: '3rd',
        congratulations: 'Congratulations!',
        bestPlayers: 'The best players of this quiz!'
      }
    }
  },
  
  // Questionnaire
  questionnaire: {
    title: 'Questionnaire title',
    description: 'Description',
    questions: 'Questions',
    question: 'Question',
    create: 'Create questionnaire',
    edit: 'Edit questionnaire',
    editDescription: 'Edit questions and branching conditions',
    generalInfo: 'General information',
    descriptionOptional: 'Description (optional)',
    addQuestion: 'Add a question',
    questionText: 'Question text',
    responseType: 'Response type',
    responseOptions: 'Response options',
    addOption: 'Add an option',
    placeholderLabel: 'Placeholder (helper text)',
    required: 'Required question',
    requiredShort: 'Required',
    conditional: 'Conditional',
    conditionalBranching: 'Conditional question (branching)',
    defineWhereToGo: 'Define where to go based on the answer:',
    ifAnswer: 'If "{{answer}}" →',
    nextQuestionDefault: 'Next question (default)',
    nextQuestion: 'Next question',
    byDefault: 'By default →',
    endOfQuestionnaire: 'End of questionnaire',
    noText: 'No text',
    questionWithoutText: 'Question without text',
    noQuestionsAdded: 'No questions added',
    addFirstQuestion: 'Add the first question',
    notFound: 'Questionnaire not found',
    noQuestions: 'This questionnaire has no questions',
    enterName: 'Please enter your name',
    startError: 'Error starting',
    invalidEmail: 'Please enter a valid email',
    selectAtLeastOne: 'Please select at least one option',
    requiredQuestion: 'This question is required',
    play: {
      title: 'Questionnaire',
      description: 'Answer the questions below',
      yourName: 'Your name',
      enterName: 'Enter your name',
      start: 'Start',
      questionOf: 'Question {{current}} of {{total}}',
      multipleAnswersPossible: 'Multiple answers possible',
      selectOption: 'Select an option',
      yourAnswer: 'Your answer',
      yourDetailedAnswer: 'Your detailed answer',
      enterNumber: 'Enter a number',
      previous: 'Previous',
      next: 'Next',
      finish: 'Finish',
      thanks: 'Thank you {{name}}!',
      responsesRecorded: 'Your responses have been recorded.',
      summary: 'Summary',
      questionsAnswered: '{{count}} question(s) answered',
      seeDetails: 'See details',
      backToHome: 'Back to home'
    },
    responses: 'Responses',
    totalResponses: 'responses received',
    noResponses: 'No responses yet',
    anonymous: 'Anonymous response',
    optional: 'Optional question',
    conditionalLogic: 'Conditional logic',
    addCondition: 'Add condition',
    thenGoTo: 'Then go to',
    questionTypes: {
      singleChoice: 'Single choice',
      multipleChoice: 'Multiple choice',
      trueFalse: 'True/False',
      dropdown: 'Dropdown',
      shortText: 'Short text',
      longText: 'Long text',
      number: 'Number',
      email: 'Email',
      date: 'Date',
      rating: 'Rating',
      yesNo: 'Yes/No'
    },
    placeholders: {
      title: 'E.g.: Satisfaction survey',
      description: 'Briefly describe your questionnaire...',
      questionText: 'Enter your question...',
      option: 'Option',
      placeholder: 'E.g.: Enter your answer...',
      shortText: 'Your answer...',
      longText: 'Write your detailed answer...',
      number: 'Enter a number',
      email: 'your@email.com',
      date: 'Select a date'
    },
    submit: 'Submit',
    submitSuccess: 'Thank you for your response!',
    submitError: 'Error submitting',
    results: {
      title: 'Results',
      summary: 'Summary',
      details: 'Details',
      export: 'Export',
      filter: 'Filter',
      respondent: 'Respondent',
      date: 'Date',
      viewResponse: 'View response'
    },
    playScreen: {
      title: 'Questionnaire',
      description: 'Description',
      yourName: 'Your name',
      enterName: 'Enter your name',
      start: 'Start',
      questionOf: 'Question {current} of {total}',
      multipleAnswersPossible: 'Multiple answers possible',
      selectOption: 'Select an option',
      yourAnswer: 'Your answer',
      yourDetailedAnswer: 'Your detailed answer',
      enterNumber: 'Enter a number',
      previous: 'Previous',
      next: 'Next',
      finish: 'Finish',
      thanks: 'Thank you!',
      responsesRecorded: 'Your responses have been recorded.',
      summary: 'Summary',
      questionsAnswered: 'Questions answered',
      seeDetails: 'See details',
      backToHome: 'Back to home'
    }
  },
  
  // Events / Gifts
  events: {
    event: 'Event',
    ourEvent: 'our event',
    title: 'Event title',
    date: 'Date',
    location: 'Location',
    guests: 'Guests',
    guest: 'Guest',
    tables: 'Tables',
    table: 'Table',
    seatingPlan: 'Seating plan',
    guestbook: 'Guestbook',
    giftList: 'Gift list',
    scanner: 'QR Scanner',
    present: 'Present',
    absent: 'Absent',
    confirmed: 'Confirmed',
    notConfirmed: 'Not confirmed',
    addGuest: 'Add guest',
    editGuest: 'Edit guest',
    deleteGuest: 'Delete guest',
    exportExcel: 'Export Excel',
    totalGuests: 'Total guests',
    couple: 'Couple',
    single: 'Single',
    family: 'Family',
    relation: 'Relation',
    capacity: 'Capacity',
    create: {
      title: 'Create event',
      subtitle: 'Configure your event and gift list',
      editTitle: 'Edit event',
      eventName: 'Event name',
      eventNamePlaceholder: 'E.g.: Sophie and Thomas\'s Wedding',
      eventNameRequired: 'Event name is required',
      eventDate: 'Event date',
      eventLocation: 'Location',
      eventLocationPlaceholder: 'E.g.: Grand Hotel',
      eventDescription: 'Description',
      eventDescriptionPlaceholder: 'Describe your event...',
      eventType: 'Event type',
      enableGiftList: 'Enable gift list',
      enableGuestbook: 'Enable guestbook',
      enableSeating: 'Enable seating plan',
      saveEvent: 'Save event',
      other: 'Other',
      basicInfo: 'Basic information',
      basicInfoDesc: 'Name, type, date and description',
      shortDescription: 'Short description',
      shortDescriptionPlaceholder: 'A brief description of your event...',
      coverImage: 'Cover image',
      publicEvent: 'Public event',
      privateEvent: 'Private event',
      accessibleWithLink: 'Accessible with link',
      restrictedAccess: 'Restricted access',
      publicEventWithLink: 'Public event (accessible to everyone with the link)',
      eventStory: 'Event story',
      eventStoryDesc: 'Tell your story to guests',
      storyHelpText: 'Share your event story. For example, for a wedding, tell how you met. This story will be displayed to your guests after registration.',
      storyPlaceholder: 'Once upon a time...',
      invitationTicket: 'Invitation ticket',
      invitationTicketDesc: 'Custom image and letter in PDF',
      howItWorks: 'How it works',
      invitationExplanation: 'Your guests can download a personalized PDF containing your invitation image + a letter with their name.',
      invitationImage: 'Invitation image (PDF Page 1)',
      invitationLetter: 'Invitation letter (PDF Page 2)',
      invitationLetterHint: 'The PDF will start with "Dear [Guest Name]," followed by your text.',
      invitationLetterPlaceholder: 'We are delighted to invite you to our wedding which will take place on...',
      photoGallery: 'Photo gallery',
      photoGalleryDesc: 'Automatic photo montage for your guests',
      galleryHelpText: 'Add up to 10 photos. An automatic collage will be created and displayed to your guests to immerse them in the atmosphere of your event.',
      collagePreview: 'Collage preview',
      managePhotos: 'Manage photos',
      createEvent: 'Create event',
      creating: 'Creating...',
      permissionDenied: 'Access denied. Your account must be validated by an administrator.',
      errorCreating: 'Error creating: {{message}}',
      howItWorksTitle: 'How it works for your guests',
      step1: 'They enter their full name',
      step2: 'They discover your story and can download their personalized invitation',
      step3: 'They access the gift list to reserve',
      showInvitationTicket: 'Show invitation ticket',
      showInvitationTicketDesc: 'Guests can see and download the ticket on the event page',
      hideInvitationTicket: 'Hide invitation ticket',
      hideInvitationTicketDesc: 'The ticket will not be visible to guests',
      backgroundMusic: 'Background music',
      backgroundMusicDesc: 'Music played in loop on the photos and story page',
      uploadMusic: 'Upload music',
      musicFormats: 'Accepted formats: MP3, M4A, WAV, OGG (max 10 MB)',
      removeMusic: 'Remove music',
      musicPlaying: 'Music playing',
      musicPaused: 'Music paused'
    },
    edit: {
      notFound: 'Event not found',
      notAuthorized: 'You are not authorized to edit this event',
      loadError: 'Error loading event',
      updateSuccess: 'Event updated successfully',
      saveError: 'Error saving',
      deleteError: 'Error deleting',
      reservationDeleted: 'Reservation deleted',
      reservationDeleteError: 'Error deleting reservation',
      linkCopied: 'Link copied!',
      eventDetails: 'Event details',
      ourStory: 'Our story',
      configured: 'Configured',
      storyDesc: 'Tell your story! Visitors will see it before accessing the gift list.',
      storyPlaceholder: 'How did you meet? Tell the highlights of your story...',
      personalizedInvitation: 'Personalized invitation',
      invitationDesc: 'Create a personalized PDF invitation that your guests can download with their name.',
      invitationImagePage1: 'Invitation image (PDF page 1)',
      formatRecommendation: 'Recommended format: A4 portrait (210x297mm)',
      letterTextPage2: 'Letter text (PDF page 2)',
      letterPlaceholder: 'Dear guest,\n\nWe are overjoyed to invite you to our wedding...',
      guestNameAutoAdded: 'The guest\'s name will be automatically added at the top of the letter',
      galleryDesc: 'Add up to 10 photos for an automatic collage that visitors will see.',
      saving: 'Saving...',
      saveAllChanges: 'Save all changes',
      managePrograms: 'Manage programs & menus',
      reservation: 'reservation',
      reservation_plural: 'reservations',
      deleteEventConfirmTitle: 'Delete event?',
      deleteEventConfirmMessage: 'This will also delete all associated gifts and reservations. This action is irreversible.',
      deleteReservationConfirmTitle: 'Delete this reservation?',
      deleteReservationConfirmMessage: 'Do you really want to delete the reservation by {{name}}?'
    },
    view: {
      event: 'Event',
      notFound: 'Event not found',
      loadError: 'Error loading event',
      loadingEvent: 'Loading event...',
      oops: 'Oops!',
      backToHome: 'Back to home',
      welcome: 'Welcome!',
      welcomeName: 'Welcome {{name}}!',
      enterNameToAccess: 'Enter your name to access the event',
      registerToAccess: 'Register to access the event and gift list',
      yourFullName: 'Your full name',
      enterFullName: 'Please enter your full name',
      fillNameRequired: 'Please fill in first and last name',
      selectRelation: 'Please select your relationship with the organizer',
      fillSpouseRequired: 'Please fill in spouse information',
      registrationError: 'Error during registration',
      registrationNote: 'Your registration will be validated by the organizer before being added to the guest list.',
      firstName: 'First name',
      lastName: 'Last name',
      firstNamePlaceholder: 'Your first name',
      lastNamePlaceholder: 'Your last name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      relationWithOrganizer: 'Relationship with organizer',
      invitationType: 'Invitation type',
      singleInvitation: 'Solo Invitation',
      coupleInvitation: 'Couple Invitation',
      spouseInfo: 'Spouse information',
      spouseFirstName: 'Spouse first name',
      spouseLastName: 'Spouse last name',
      spouseGender: 'Spouse gender',
      toTheEvent: 'to the event',
      ourStory: 'Our story',
      yourPersonalizedInvitation: 'Your personalized invitation',
      downloadPdfWithName: 'Download your PDF invitation with your name',
      generating: 'Generating...',
      downloadAgain: 'Download again',
      downloadMyInvitation: 'Download my invitation',
      invitationDownloadedSuccess: 'Invitation downloaded successfully!',
      pdfDownloaded: '🎉 Your personalized invitation has been downloaded!',
      pdfError: 'Error generating PDF',
      discoverGiftList: 'Discover the gift list',
      chooseGiftToOffer: 'Choose the gift you want to offer',
      listEmpty: 'The list is empty for now',
      noGiftsYet: 'The organizer has not added any gifts yet.',
      on: 'on',
      reserveThisGift: 'Reserve this gift',
      yourName: 'Your name',
      enterYourName: 'Please enter your name',
      stayAnonymous: 'Stay anonymous',
      onlyOrganizerSees: 'Only you and the organizer will see your name; others will see “anonymous”',
      you: 'you',
      anonymousSelfNote: 'Only you and the organizer can see your name. Others see “anonymous”.',
      howManyReserve: 'How many would you like to reserve?',
      outOf: 'out of',
      available: 'available',
      messageOptional: 'Message (optional)',
      messagePlaceholder: 'A little note for the organizers... 💝',
      visibleToOrganizerOnly: 'Visible only to the organizer',
      reserving: 'Reserving...',
      onlyRemainingReservations: 'Only {{count}} reservation(s) remaining',
      reservationSuccess: 'Thank you {{name}}! 🎉 Your reservation has been saved.',
      reservationError: 'Error making reservation',
      linkCopied: '✨ Link copied to clipboard!',
      iOfferIt: 'I\'ll give this!',
      ourGallery: 'Our Gallery',
      photosAutoScroll: '{{count}} photo(s) • Auto scroll',
      photoOf: 'Photo {{current}} / {{total}}'
    },
    gifts: {
      title: 'Gift list',
      gifts: 'Gifts',
      gift: 'gift',
      gift_plural: 'gifts',
      addGift: 'Add gift',
      editGift: 'Edit gift',
      giftName: 'Gift name',
      giftNamePlaceholder: 'E.g.: Kitchen robot',
      giftNameRequired: 'Gift name is required',
      giftPrice: 'Price (€)',
      giftDescription: 'Description',
      giftImage: 'Image',
      giftLink: 'External link',
      available: 'Available',
      reserved: 'Reserved',
      purchased: 'Purchased',
      reserveGift: 'Reserve this gift',
      cancelReservation: 'Cancel reservation',
      reservedBy: 'Reserved by',
      participateAmount: 'Contribute (any amount)',
      totalCollected: 'Total collected',
      contributions: 'contributions',
      noGifts: 'No gifts in the list',
      addFirst: 'Add gifts to get started',
      giftUpdated: 'Gift updated',
      giftAdded: 'Gift added',
      giftDeleted: 'Gift deleted',
      giftSaveError: 'Error saving gift',
      deleteGiftConfirm: 'Delete this gift?',
      notesVisibleToGuests: 'Notes (visible to guests)',
      notesPlaceholder: 'E.g.: Preferred color: red',
      allowMultipleReservations: 'Allow multiple reservations',
      giftType: 'Gift type',
      typeArticle: 'Article',
      typeArticleDesc: 'A classic article to offer',
      typeMoney: 'Money',
      typeMoneyDesc: 'Free financial contribution',
      typeShared: 'Shared article',
      typeSharedDesc: 'Article whose price is shared among several guests',
      targetAmount: 'Target amount (€)',
      targetAmountPlaceholder: 'E.g.: 500',
      yourContribution: 'Your contribution (€)',
      contributionPlaceholder: 'Enter an amount',
      amountRequired: 'Please enter an amount',
      amountTooHigh: 'Amount exceeds remaining to collect ({{remaining}}€)',
      contributionSuccess: 'Thank you {{name}}! 🎉 Your contribution of {{amount}}€ has been recorded.',
      contributionUpdated: 'Your contribution has been updated.',
      yourPreviousContribution: 'Your previous contribution',
      updateContribution: 'Update my contribution',
      remainingAmount: 'Remaining to collect',
      goalReached: 'Goal reached! 🎉',
      goalReachedDesc: 'The target amount has been reached',
      progressLabel: 'Progress',
      contributorsCount: '{{count}} contributor(s)',
      enterValidAmount: 'Please enter a valid amount',
      moneyGiftName: 'Financial contribution',
      moneyGiftDesc: 'Guests contribute the amount of their choice',
      privateContribution: 'Your contribution is private and visible only to you and the organizer',
      sendMoney: 'Send money',
      paymentLink: 'Payment link (bank, PayPal, Lydia...)',
      paymentLinkDesc: 'Guests will be able to click to send money directly',
      reservationsPossible: '{{count}} reservation(s) available',
      imageByUrl: 'Image by URL',
      imageByUrlPlaceholder: 'https://example.com/image.jpg',
      imageByUpload: 'Image by upload',
      orUseUrl: 'Or paste an image URL'
    },
    invitation: {
      title: 'Invitation',
      createPdf: 'Create PDF',
      sendEmail: 'Send by email',
      copyLink: 'Copy link',
      qrCode: 'QR Code',
      preview: 'Preview'
    }
  },
  
  // Guestbook
  guestbook: {
    title: 'Guestbook',
    theGuestbook: 'The Guestbook',
    leaveMessage: 'Leave a message',
    leaveNote: 'Leave a note',
    leaveNoteDesc: 'Share your wishes, an anecdote or a photo memory to celebrate this moment with us.',
    leaveEternalMemory: 'Leave an eternal memory',
    leaveEternalMemoryDesc: 'Immortalize your presence with a 3D message for the couple.',
    yourName: 'Your name',
    yourMessage: 'Your message',
    writeMemorable: 'Write something memorable...',
    characters: 'characters',
    photoMemory: 'Photo Memory',
    photoFormats: 'JPG, PNG (max 5MB)',
    addPhoto: 'Add photo',
    send: 'Send',
    sign: 'Sign',
    signBook: 'Sign the Guestbook',
    signTheBook: 'Sign the book',
    readBook: 'Read the book',
    messages: 'Messages',
    noMessages: 'No messages yet',
    noMessagesYet: 'No messages yet...',
    beFirst: 'Be the first to sign!',
    deleteMessage: 'Delete this message',
    deleteConfirm: 'Are you sure you want to delete this message?',
    messageDeleted: 'Message deleted',
    from: 'From:',
    withLove: '– With all our love ❤️',
    memories: 'Memories...',
    pageOf: 'PAGE {{current}} OF {{total}}',
    latestMessages: 'Latest messages',
    photoShared: '📷 Photo shared',
    experience3d: '3D Experience',
    howItWorks: 'How does it work?',
    takePhoto: 'Take a photo',
    writeWord: 'Write a note',
    imageTooLarge: 'Image too large (max 5 MB)',
    invalidFile: 'Invalid file',
    enterName: 'Please enter your name',
    addMessageOrPhoto: 'Add a message or photo',
    messageAdded: 'Message added! 💕',
    sendError: 'Error while sending',
    minutesAgo: '{{count}} min ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
    noMessagesToExport: 'No messages to export',
    generatingPdf: 'Generating PDF...',
    generatedOn: 'Generated on',
    messagesCount: 'message(s)',
    pdfDownloaded: 'PDF downloaded!',
    pdfError: 'Error generating PDF',
    shareLink: 'Share link',
    downloadPdf: 'Download PDF',
    linkShared: 'Link shared!',
    linkCopied: 'Link copied to clipboard!',
    copyError: 'Unable to copy link',
    shareText: 'Leave a message in the guestbook of {{eventName}}! 💌',
    anonymous: 'Anonymous',
    messagesPublic: 'Messages visible to everyone',
    messagesPrivate: 'Messages visible to you only',
    messagesPublicDesc: 'Guests can read other people\'s messages',
    messagesPrivateDesc: 'Guests can only write, only you can read'
  },

  // Guests
  guests: {
    title: 'Guest List',
    addGuest: 'Add Guest',
    editGuest: 'Edit Guest',
    firstName: 'First Name',
    lastName: 'Last Name',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    ticketType: 'Ticket Type',
    single: 'Single',
    couple: 'Couple',
    spouseInfo: 'Spouse Information',
    relation: 'Relation with organizer',
    selectRelation: '-- Select --',
    table: 'Table',
    tableOptional: 'Table (optional)',
    notAssigned: '-- Not assigned --',
    cancel: 'Cancel',
    addTheGuest: 'Add guest',
    saveChanges: 'Save',
    totalGuests: 'Total Guests',
    tickets: 'Tickets',
    present: 'Present',
    absent: 'Absent',
    presents: 'Present',
    absents: 'Absent',
    searchGuest: 'Search guest...',
    allStatuses: 'All statuses',
    allTickets: 'All tickets',
    noGuests: 'No guests yet',
    noMatchingGuests: 'No guest matches your search',
    addFirstGuest: 'Add first guest',
    guest: 'Guest',
    type: 'Type',
    statusClick: 'Status (click to change)',
    actions: 'Actions',
    downloadPdf: 'Download PDF',
    edit: 'Edit',
    deleteGuest: 'Delete',
    yourInvitation: 'Your Invitation Ticket',
    coupleTicket: 'Couple Ticket with',
    scanQrCode: 'Scan this QR code at the entrance',
    personalTicket: 'This ticket is personal and non-transferable',
    sortNameAsc: 'Name (A → Z)',
    sortNameDesc: 'Name (Z → A)',
    sortFirstNameAsc: 'First name (A → Z)',
    sortFirstNameDesc: 'First name (Z → A)',
    sortDateRecent: 'Most recent',
    sortDateOldest: 'Oldest',
    sortByTable: 'By table',
    sortByRelation: 'By relation',
    sortPresentFirst: 'Present first',
    sortAbsentFirst: 'Absent first',
    tables: 'Tables',
    scanner: 'Scanner',
    plan: 'Plan',
    guestbook: 'Guestbook',
    excel: 'Excel',
    add: 'Add',
    // Excel export fields
    number: 'No.',
    arrivalDate: 'Arrival Date',
    registrationDate: 'Registration Date',
    spouseFirstName: 'Spouse First Name',
    spouseLastName: 'Spouse Last Name',
    spouseGender: 'Spouse Gender',
    spouseStatus: 'Spouse Status',
    spouseArrival: 'Spouse Arrival',
    // Summary sheet
    statistic: 'Statistic',
    value: 'Value',
    summary: 'Summary',
    totalInvitations: 'Total invitations',
    totalPersons: 'Total persons',
    guestsPresent: 'Guests present',
    guestsAbsent: 'Guests absent',
    couples: 'Couples',
    singles: 'Singles',
    spousesPresent: 'Spouses present',
    exportDate: 'Export date',
    // Pending guests
    pendingApproval: 'Pending',
    pendingRequests: 'Pending requests',
    confirmedList: 'Confirmed list',
    noPendingRequests: 'No pending requests',
    noPendingDescription: 'Guests who register via the event link will appear here for validation.',
    pendingInfo: 'These people registered via the event link and are awaiting your validation.',
    requestedOn: 'Requested on',
    approve: 'Approve',
    reject: 'Reject',
    pendingApproved: 'Guest approved and added to the list',
    pendingRejected: 'Request rejected',
    approveError: 'Error during approval',
    rejectError: 'Error during rejection'
  },

  // Relations
  relations: {
    fatherGroom: 'Father of the groom',
    motherGroom: 'Mother of the groom',
    brotherGroom: 'Brother of the groom',
    sisterGroom: 'Sister of the groom',
    fatherBride: 'Father of the bride',
    motherBride: 'Mother of the bride',
    brotherBride: 'Brother of the bride',
    sisterBride: 'Sister of the bride',
    grandparent: 'Grandparent',
    uncle: 'Uncle',
    aunt: 'Aunt',
    cousin: 'Cousin',
    nephew: 'Nephew/Niece',
    childhoodFriend: 'Childhood friend',
    closeFriend: 'Close friend',
    colleague: 'Colleague',
    neighbor: 'Neighbor',
    witness: 'Witness',
    bridesmaid: 'Bridesmaid',
    groomsman: 'Groomsman',
    otherFamily: 'Other family',
    otherFriend: 'Other friend',
    professional: 'Professional',
    other: 'Other'
  },

  // Event Types
  eventTypes: {
    wedding: 'Wedding',
    birthday: 'Birthday',
    birth: 'Birth',
    baptism: 'Baptism',
    housewarming: 'Housewarming',
    christmas: 'Christmas',
    other: 'Event'
  },

  // Event Responses / Statistics
  eventResponses: {
    title: 'Statistics',
    backToDashboard: 'Back to dashboard',
    stats: {
      giftsReserved: 'Gifts reserved',
      participants: 'Participants',
      reservations: 'Reservations',
      reservedValue: 'Reserved value'
    },
    progress: 'Progress',
    reservationsList: 'Reservations list',
    giftSummary: 'Gift summary',
    anonymous: 'anonymous',
    giftDeleted: 'Gift deleted',
    deleteReservation: 'Delete reservation',
    noReservations: 'No reservations yet',
    shareToReceive: 'Share your list to receive reservations',
    reservation: 'reservation',
    notReserved: 'Not reserved',
    reserved: 'Reserved',
    available: 'Available',
    confirmDelete: 'Delete this reservation?',
    deleteSuccess: 'Reservation deleted',
    errors: {
      notFound: 'Event not found',
      unauthorized: 'You are not authorized to view these statistics',
      loadError: 'Error loading data',
      deleteError: 'Error deleting'
    }
  },

  // Profile
  profile: {
    title: 'My Profile',
    subtitle: 'Manage your personal information',
    personalInfo: 'Personal Information',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    bio: 'Biography',
    bioPlaceholder: 'Tell us about yourself...',
    address: 'Address',
    streetName: 'Street',
    streetNumber: 'No.',
    postalCode: 'Postal code',
    city: 'City',
    country: 'Country',
    photoUpdated: 'Profile picture updated',
    photoError: 'Error uploading photo',
    photoDeleted: 'Profile picture deleted',
    deletePhoto: 'Delete',
    deletePhotoError: 'Error deleting photo',
    invalidImageType: 'Please select an image',
    imageTooLarge: 'Image must not exceed 5MB',
    updated: 'Profile updated successfully',
    updateError: 'Error updating profile',
    upgradeToPro: 'Upgrade to Pro',
    managePlan: 'Manage my subscription',
    unlockFeatures: 'Unlock all features and unlimited participants',
    currentPlan: 'Your current plan: {{plan}}',
    renewsIn: 'Renews in {{days}} days',
    endsIn: 'Ends in {{days}} days',
    manageSubscription: 'Manage / Cancel',
    seePlans: 'See plans',
    changePlan: 'Change',
    subscriptionSettings: 'Subscription settings',
    managePayments: 'Manage payments and billing',
    viewPlans: 'View plans',
    comparePlans: 'Compare available offers',
    logoutDesc: 'Log out of your account',
    legalInfo: 'Legal information',
    dangerZone: 'Danger zone',
    deleteAccountWarning: 'Account deletion is irreversible. All your data will be permanently deleted.',
    deleteAccount: 'Delete my account',
    confirmDeletion: 'Confirm deletion',
    actionIrreversible: 'This action is irreversible',
    importantNotice: 'Important notice',
    deleteWarning1: 'All your quizzes, questionnaires and events will be deleted',
    deleteWarning2: 'Your personal data will be permanently erased',
    deleteWarning3: 'You will no longer be able to access your account',
    deleteWarning4: 'If your subscription renews in less than 48h and you haven\'t cancelled the renewal, the last charge will be processed before deletion.',
    typeConfirm: 'Type "DELETE" to confirm:',
    typeSupprimer: 'Please type "DELETE" to confirm',
    accountMarkedDeleted: 'Account marked for deletion. The last charge will be processed.',
    accountDeleted: 'Account deleted successfully',
    deleteError: 'Error deleting account',
    confirmDelete: 'Delete permanently',
    adminGrantedAccess: 'Access granted by administrator',
    adminGrantedAccessDesc: 'You have full access granted by the administrator.',
    revokeAccess: 'Revoke this access',
    revokeAccessConfirm: 'Revoke my access',
    revokeAccessDesc: 'This action will remove your granted access. You will return to the free plan.'
  },
  
  // Settings
  settings: {
    title: 'Account settings',
    description: 'Manage your personal information and settings',
    profile: 'Profile',
    language: 'Language',
    theme: 'Theme',
    notifications: 'Notifications',
    security: 'Security',
    changePassword: 'Change password',
    deleteAccount: 'Delete account',
    currentInfo: 'Current information',
    displayName: 'Display name',
    currentEmail: 'Current email',
    notDefined: 'Not defined',
    preferences: 'Preferences',
    tutorial: 'Tutorial',
    restartTutorial: 'Restart tutorial',
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    systemDefault: 'System',
    saveChanges: 'Save changes',
    accountDanger: 'Danger zone',
    deleteAccountWarning: 'This action is irreversible. All your data will be deleted.',
    deleteAccountConfirm: 'Are you sure you want to delete your account?',
    email: {
      changeEmail: 'Change email',
      newEmail: 'New email',
      confirmNewEmail: 'Confirm new email',
      currentPassword: 'Current password (to confirm)',
      passwordHelp: 'Enter your current password to confirm the change',
      updateEmail: 'Update email',
      updating: 'Updating...',
      fillAllFields: 'Please fill in all fields',
      emailsMismatch: 'Emails do not match',
      sameEmail: 'The new email is the same as the current one',
      invalidFormat: 'Invalid email format',
      verificationSent: '📧 A verification email has been sent to {{email}}. Click the link to confirm the change.',
      verificationSentTitle: 'Verification email sent!',
      verificationSentDesc: 'Check your inbox and click the link to confirm',
      wrongPassword: 'Incorrect password',
      emailInUse: 'This email is already used by another account',
      sessionExpired: 'Session expired. Please log in again.',
      operationNotAllowed: 'Operation not allowed. Check Firebase settings.',
      updateError: 'Error during update',
      howItWorks: 'How does it work?',
      step1: '1. Enter your new email and current password',
      step2: '2. A verification email will be sent to the new address',
      step3: '3. Click the link in the email to confirm the change',
      important: 'Important',
      importantDesc: 'Changing your email will change the identifier you use to log in. You will need to use the new email on your next login.'
    }
  },
  
  // Admin
  admin: {
    title: 'Administration',
    users: 'Users',
    userManagement: 'User management',
    pendingUsers: 'Pending users',
    validatedUsers: 'Validated users',
    allUsers: 'All users',
    validateUser: 'Validate user',
    rejectUser: 'Reject user',
    makeAdmin: 'Make admin',
    removeAdmin: 'Remove admin',
    deleteUser: 'Delete user',
    userValidated: 'User validated',
    userRejected: 'User rejected',
    tabs: {
      overview: 'Overview',
      content: 'Content',
      activity: 'Activity',
      settings: 'Settings',
      storage: 'Storage',
      services: 'Services',
      messaging: 'Messaging'
    },
    messaging: {
      title: 'Send a message',
      subtitle: 'Write to one, several or all users. The message is delivered by email and notification.',
      allUsers: 'All users',
      selectUsers: 'Select users',
      searchUser: 'Search a user...',
      toggleAll: 'Select/deselect all',
      noUsers: 'No user',
      subject: 'Subject',
      subjectPlaceholder: 'Subject of your message',
      message: 'Message',
      messagePlaceholder: 'Write your message here...',
      emailHint: 'The email will be styled with the HugoQuiz design and a button to the site.',
      send: 'Send message',
      sending: 'Sending...',
      needSubject: 'Please enter a subject.',
      needMessage: 'Please enter a message.',
      needRecipients: 'Select at least one recipient.',
      confirm: 'Send this message to {{count}} user(s)?',
      sent: 'Message sent to {{sent}}/{{total}} user(s).'
    },
    services: {
      verifications: 'Verifications',
      servicesList: 'Services',
      reviews: 'Reviews',
      noReviews: 'No reviews awaiting validation.',
      reviewApproved: 'Review published',
      reviewRejected: 'Review rejected',
      noVerifications: 'No pending verification requests.',
      noServices: 'No services.',
      idDocument: 'ID document',
      openPdf: 'Open PDF',
      selfieVideo: 'Selfie video',
      approve: 'Approve',
      reject: 'Reject',
      publish: 'Publish',
      restrict: 'Restrict',
      preview: 'View',
      verifApproved: 'Identity approved',
      verifRejected: 'Request rejected',
      serviceApproved: 'Service published',
      serviceUpdated: 'Service updated',
      serviceDeleted: 'Service deleted',
      messagePlaceholder: 'Message explaining the reason (sent to the user)',
      statusPending: 'Pending',
      statusApproved: 'Published',
      statusRejected: 'Rejected',
      statusRestricted: 'Restricted',
      seedHint: 'Create two demo services (Hugographie — photographer/videographer, and Hugo — event planner) linked to your admin account.',
      seedButton: 'Create demo services',
      seedConfirm: 'Create the demo services Hugographie and Hugo on your admin account?',
      seedDone: 'Demo services created and published!',
      rejectVerifTitle: 'Reject verification request',
      rejectServiceTitle: 'Reject this service',
      restrictTitle: 'Restrict the display of this service',
      deleteTitle: 'Permanently delete this service',
      filter: { all: 'All', pending: 'Pending', approved: 'Published', rejected: 'Rejected', restricted: 'Restricted' }
    },
    storage: {
      title: 'Storage Management',
      description: 'Monitor and manage storage space for each user',
      searchUser: 'Search user...',
      totalUsers: 'Users',
      usageOk: 'Usage OK',
      nearLimit: 'Near limit',
      exceeded: 'Exceeded',
      loading: 'Loading storage data...',
      noData: 'Click Refresh to load data',
      user: 'User',
      usage: 'Usage',
      limit: 'Limit',
      status: 'Status',
      actions: 'Actions',
      editLimit: 'Edit limit',
      recalculate: 'Recalculate storage',
      ok: 'OK',
      warning: 'Warning',
      critical: 'Critical'
    },
    quizMusic: {
      title: 'Quiz Music',
      description: 'Manage music played during quizzes',
      lobby: 'Lobby music',
      lobbyDesc: 'Music played in waiting room',
      effects: 'Sound effects',
      effectsDesc: 'Countdown, transitions, results',
      gameplay: 'Gameplay music',
      gameplayDesc: 'Music by question duration',
      upload: 'Upload',
      delete: 'Delete',
      play: 'Play',
      pause: 'Pause',
      noMusic: 'No music',
      addMusic: 'Add music',
      categories: {
        lobby: 'Waiting room',
        countdown: 'Countdown',
        transition: 'Transition',
        results: 'Results',
        podium: 'Podium'
      }
    },
    chat: {
      title: 'Chat Management',
      subtitle: 'Respond to users waiting for help',
      description: 'Respond to users who need human assistance.',
      manage: 'Manage chats',
      waiting: 'Waiting',
      active: 'Active',
      waitingTag: 'Waiting',
      humanMode: 'Human',
      noConversations: 'No conversations',
      selectConversation: 'Select a conversation',
      selectHint: 'Click on a conversation on the left to begin',
      placeholder: 'Type your response...',
      returnToBot: 'Return to bot',
      close: 'Close',
      confirmClose: 'Are you sure you want to close this conversation?',
      confirmReturnToBot: 'Do you want to return control to the bot?',
      conversationClosed: 'Conversation closed',
      returnedToBot: 'Conversation returned to bot',
      botModeWarning: 'This conversation is currently managed by the bot.',
      takeOver: 'Take over'
    }
  },
  
  // Chatbot
  chatbot: {
    title: 'HugoQuiz Assistant',
    placeholder: 'Ask your question...',
    greeting: 'Hello! How can I help you?',
    suggestions: [
      'How to create a quiz?',
      'How to add guests?',
      'How does the QR code work?'
    ],
    talkToHuman: 'Talk to a team member',
    waitingForTeam: 'Waiting for team...',
    teamResponding: 'HugoQuiz Team',
    online: 'Online',
    conversationEnded: 'Conversation ended'
  },
  
  // Tutorial
  tutorial: {
    welcome: 'Welcome to HugoQuiz!',
    welcomeDesc: 'Let us guide you through all the features.',
    start: 'Start tutorial',
    skip: 'Skip',
    next: 'Next',
    prev: 'Previous',
    finish: 'Finish',
    step: 'Step',
    of: 'of',
    steps: {
      dashboard: {
        title: 'Your dashboard',
        content: 'Here you can find all your quizzes, questionnaires and events.'
      },
      createQuiz: {
        title: 'Create a quiz',
        content: 'Click here to create a new interactive quiz with questions and a timer.'
      },
      createEvent: {
        title: 'Create an event',
        content: 'Manage your weddings, birthdays and parties with guest lists, QR codes and seating plans.'
      },
      settings: {
        title: 'Settings',
        content: 'Customize your profile, change language and manage your preferences.'
      },
      chatbot: {
        title: 'Need help?',
        content: 'Our smart assistant is always here to answer your questions!'
      }
    }
  },
  
  // Keyboard shortcuts
  shortcuts: {
    title: 'Keyboard shortcuts',
    show: 'Show shortcuts',
    navigation: 'Navigation',
    actions: 'Actions',
    goHome: 'Go to home',
    goDashboard: 'Go to dashboard',
    goSettings: 'Go to settings',
    newQuiz: 'New quiz',
    newEvent: 'New event',
    search: 'Search',
    help: 'Help / Shortcuts'
  },
  
  // Errors
  errors: {
    general: 'An error occurred',
    notFound: 'Page not found',
    unauthorized: 'Unauthorized access',
    forbidden: 'Forbidden access',
    serverError: 'Server error',
    networkError: 'Network error',
    timeout: 'Request timeout',
    tryAgain: 'Please try again',
    contactSupport: 'Contact support if the problem persists'
  },
  
  // Validation
  validation: {
    required: 'This field is required',
    email: 'Invalid email',
    minLength: 'Minimum {{min}} characters',
    maxLength: 'Maximum {{max}} characters',
    passwordMatch: 'Passwords do not match',
    invalidFormat: 'Invalid format',
    tooShort: 'Too short',
    tooLong: 'Too long'
  },
  
  // Time
  time: {
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    ago: 'ago',
    remaining: 'remaining',
    justNow: 'Just now',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow'
  },

  // Subscription & Pricing
  subscription: {
    title: 'Subscription',
    mySubscription: 'My subscription',
    choosePlan: 'Choose your plan',
    subtitle: 'Powerful tools for creating interactive quizzes and events',
    month: 'month',
    year: 'year',
    monthly: 'Monthly',
    yearly: 'Yearly',
    savePercent: 'Save {{percent}}%',
    currentPlan: 'Current plan',
    popular: 'Popular',
    bestValue: 'Best value',
    select: 'Select this plan',
    upgrade: 'Upgrade',
    downgrade: 'Downgrade',
    manage: 'Manage',
    
    // Plan names
    plans: {
      free: 'Free',
      freeDesc: 'To discover the platform',
      quizQuestionnaire: 'Quiz & Questionnaires',
      quizQuestionnaireDesc: 'For content creators',
      events: 'Events',
      eventsDesc: 'For event organizers',
      complete: 'Complete',
      completeDesc: 'Access to all features',
      adminGranted: 'Granted access',
      quizMonthly: 'Quiz & Questionnaire - Monthly',
      eventsMonthly: 'Events - Monthly',
      completeMonthly: 'Complete - Monthly',
      quizYearly: 'Quiz & Questionnaire - Yearly',
      eventsYearly: 'Events - Yearly',
      completeYearly: 'Complete - Yearly'
    },

    // Admin granted access
    adminGranted: {
      title: 'Access granted by administrator',
      description: 'You benefit from free access granted by an administrator. This access can be revoked at any time.',
      renounceTitle: 'Renounce this access',
      renounceDesc: 'If you no longer need this access, you can renounce it and return to the free plan.',
      renounceBtn: 'Renounce my access'
    },

    // Features
    features: {
      quiz: 'Interactive quizzes',
      questionnaire: 'Questionnaires',
      events: 'Events',
      participants: '{{count}} participants max',
      participantsUnlimited: 'Unlimited participants',
      liveMode: 'Live mode',
      analytics: 'Detailed analytics',
      export: 'Data export',
      support: 'Priority support'
    },

    // Status
    status: {
      active: 'Active',
      expiringSoon: 'Expiring soon',
      expired: 'Expired',
      free: 'Free',
      cancelled: 'Cancelled',
      past_due: 'Payment pending',
      payment_failed: 'Payment failed'
    },

    // Messages
    expiresIn: 'Expires in {{days}} days',
    expiringSoonWarning: 'Your subscription is expiring soon',
    expiringSoonDesc: 'Renew to keep access to your data.',
    expiredWarning: 'Your subscription has expired',
    expiredDesc: 'Your questionnaires and events will be deleted in 30 days if you do not renew.',
    paymentFailedWarning: 'Payment failed',
    paymentFailedDesc: 'We were unable to process your payment. Please update your payment information to keep your subscription.',
    pastDueWarning: 'Payment pending - Grace period',
    pastDueDesc: 'Your payment has failed but you have a 7-day grace period. Update your payment method to avoid suspension.',
    gracePeriodEnds: 'Grace period ends in {{days}} days',
    updatePaymentMethod: 'Update payment method',
    paymentRecovered: 'Payment successful! Your subscription is active again.',
    upgradeToPro: 'Upgrade to Pro',
    managePayment: 'Manage payment',
    changePlan: 'Change plan',
    cancelSubscription: 'Cancel subscription',

    // Cancellation
    cancellation: {
      title: 'Cancellation',
      willNotRenew: 'Your subscription will not be renewed',
      activeUntil: 'It remains active until the end of the current period.',
      reactivate: 'Reactivate renewal',
      refundAvailable: 'Refund available',
      refundTimeLeft: 'You have {{minutes}} minutes left to request a full refund.',
      requestRefund: 'Request a refund',
      cancelRenewal: 'Cancel renewal',
      cancelRenewalDesc: 'Your subscription will remain active until the end of the period. No refund will be made.',
      cancelRenewalBtn: 'Do not renew',
      confirmRefund: 'Confirm refund',
      confirmCancel: 'Confirm cancellation',
      terminateTitle: 'Terminate my plan',
      terminateDesc: 'Termination is immediate: you lose your plan benefits right away and no refund is possible.',
      terminateBtn: 'Terminate immediately',
      terminateConfirmTitle: 'Terminate plan?',
      terminateWarn1: 'The loss of plan benefits is immediate.',
      terminateWarn2: 'No refund is possible, in accordance with the terms of use.',
      terminateWarn3: 'You will immediately return to the free plan.',
      errorTerminate: 'Error during termination'
    },

    processing: 'Processing...',
    redirectingToStripe: 'Redirecting to Stripe...',
    successTitle: 'Payment successful! 🎉',
    successMessage: 'Your subscription is now active. Enjoy all the features!',
    cancelTitle: 'Payment cancelled',
    cancelMessage: 'You can try again anytime.',
    goToDashboard: 'Go to dashboard',
    tryAgain: 'Try again',

    // Errors
    errorCreatingCheckout: 'Error creating checkout session',
    errorOpeningPortal: 'Error opening management portal',
    
    // Guarantees
    guarantee: {
      cancel: 'Cancel anytime',
      secure: 'Secure payment',
      support: 'Support included'
    },
    
    // Subscription management
    manageExisting: 'Manage my existing subscription or cancel',
    perMonth: 'per month',
    perYear: 'per year',
    save: 'Save',
    subscribe: 'Subscribe',
    currentPlanBadge: 'Your current plan',
    unlimitedQuiz: 'Unlimited quizzes',
    noQuiz: 'Quizzes not included',
    unlimitedQuestionnaire: 'Unlimited questionnaires',
    noQuestionnaire: 'Questionnaires not included',
    unlimitedEvents: 'Unlimited events',
    noEvents: 'Events not included',
    unlimitedParticipants: 'Unlimited participants',
    startTrial: '7-day free trial',
    trialNotEligible: 'You are not eligible for the free trial',
    
    // Trial
    trial: {
      banner: '7-day free trial!',
      bannerDesc: 'Test all features with no commitment. Cancel anytime.',
      cardRequired: 'Credit card required',
      alreadyUsed: 'You have already used your free trial.',
      adminGranted: 'Free trial is not available for accounts that received complimentary access.',
      notEligible: 'You are not eligible for the free trial.',
      modalTitle: '7-day free trial',
      benefit1: 'Full access to all features for 7 days',
      benefit2: 'Cancel anytime before the trial ends',
      warning: 'Credit card required. Automatic charge of €{{price}}/month on day 8 if not cancelled.',
      uniqueOffer: 'The free trial is only available once per user, regardless of the plan chosen.',
      confirm: 'Start trial',
      active: 'Free trial active',
      endsIn: 'Ends in {{days}} days',
      endsToday: 'Ends today',
      chargeDate: 'First charge scheduled on {{date}}',
      endsOn: 'Trial ends on {{date}}',
      cancelAnytime: 'Cancel anytime at no cost',
      cancelBtn: 'Cancel free trial',
      confirmCancel: 'Are you sure you want to cancel your free trial? You will return to the free plan and will not be able to use a trial again.',
      errorCancel: 'Error cancelling trial'
    },
    
    freeFeatures: {
      quiz: 'Quiz (5 participants max)',
      questionnaire: 'Questionnaires',
      events: 'Events'
    }
  },

  // Pricing page
  pricing: {
    title: 'Pricing',
    heroTitle: 'Plans tailored to your needs',
    heroSubtitle: 'Start for free, scale as you grow',
    faq: 'Frequently asked questions',
    allFeaturesIncluded: 'All features included',
    perMonth: '/month',
    perYear: '/year',
    startFree: 'Start for free',
    getStarted: 'Get started'
  },

  // Seating Plan
  seatingPlan: {
    title: 'Seating Plan',
    loading: 'Loading seating plan...',
    unsaved: 'Unsaved',
    saved: 'Plan saved!',
    save: 'Save',
    unplacedGuests: 'Unplaced guests',
    allGuestsPlaced: 'All guests are seated!',
    addTable: 'Add table',
    addElement: 'Add element',
    entrance: 'Entrance',
    mainEntrance: 'Main entrance',
    stage: 'Stage',
    entranceAdded: 'Entrance added',
    stageAdded: 'Stage added',
    dimensions: 'Plan dimensions',
    width: 'Width',
    height: 'Height',
    default: 'Default',
    large: 'Large',
    extraLarge: 'Extra large',
    xxl: 'XXL',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    resetView: 'Reset view',
    fullscreen: 'Fullscreen',
    adjustDimensions: 'Adjust dimensions',
    toggleInitials: 'Show/hide guest initials',
    noTables: 'No tables yet',
    createFirstTable: 'Create first table',
    color: 'Color',
    shape: 'Shape',
    size: 'Size',
    guests: 'Guests',
    dragGuestsHere: 'Drag guests here',
    deleteTable: 'Delete table',
    confirmDeleteTable: 'Delete table "{{name}}"?',
    newTable: 'New table',
    tableName: 'Table name',
    tableNamePlaceholder: 'Table 1, Head table...',
    capacity: 'Capacity (persons)',
    create: 'Create'
  },

  // Table Management
  tableManagement: {
    title: 'Table Management',
    guestList: 'Guest List',
    addTable: 'Add Table',
    tables: 'Tables',
    totalCapacity: 'Total capacity',
    seatedGuests: 'Seated guests',
    notSeated: 'Not seated',
    noGuestAssigned: 'No guest assigned',
    removeFromTable: 'Remove from table',
    add: 'Add',
    noTableCreated: 'No tables created',
    createFirstTable: 'Create first table',
    unplacedGuests: 'Unplaced guests',
    place: 'Place →',
    addTableTitle: 'Add Table',
    tableNameLabel: 'Table name *',
    tableNamePlaceholder: 'Ex: Bride & Groom Table, Table 1...',
    capacityLabel: 'Capacity (number of people)',
    createTable: 'Create table',
    editTableTitle: 'Edit Table',
    addTo: 'Add to {{name}}',
    allGuestsSeated: 'All guests are already seated',
    confirmDelete: 'Confirm deletion',
    confirmDeleteMessage: 'Are you sure you want to delete the table',
    guestsWillBeUnassigned: 'Guests assigned to this table will be marked as "not seated".',
    present: 'Present',
    absent: 'Absent',
    markPresent: 'Mark as present',
    markAbsent: 'Mark as absent',
    presenceChanged: '{{name}} marked as {{status}}',
    presenceError: 'Error while changing status',
    presentCount: '{{count}}/{{total}} present',
    sortLabel: 'Sort tables',
    sortNameAsc: 'Name (A → Z)',
    sortNameDesc: 'Name (Z → A)',
    sortCapacityDesc: 'Capacity (descending)',
    sortCapacityAsc: 'Capacity (ascending)',
    sortOccupancyDesc: 'Occupancy (descending)',
    sortOccupancyAsc: 'Occupancy (ascending)'
  },

  // QR Scanner
  qrScanner: {
    title: 'QR Code Scanner',
    guestList: 'Guest List',
    tables: 'Tables',
    scanTicket: 'Scan a ticket',
    scanInstructions: 'Point the camera at the invitation ticket QR code',
    coupleTicket: 'Couple Ticket - Select person',
    present: 'PRESENT',
    absent: 'ABSENT',
    name: 'Name',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    ticketType: 'Ticket type',
    couple: 'Couple',
    single: 'Single',
    organizerRelation: 'Relation with organizer',
    assignedTable: 'Assigned table',
    coupleStatus: 'Couple status',
    presentStatus: 'Present',
    absentStatus: 'Absent',
    presentFemale: 'Present',
    absentFemale: 'Absent',
    markPresent: 'Mark Present',
    markAbsent: 'Mark Absent',
    scanAnother: 'Scan another ticket',
    instructions: 'Instructions',
    instruction1: 'Scan the QR code on the invitation ticket',
    instruction2: 'Verify the guest information',
    instruction3: 'Change the presence status if needed',
    instruction4: 'For couple tickets, select the relevant person',
    instruction5: 'You can scan the same ticket multiple times',
    markedAs: '{{name}} marked as {{status}}'
  },

  // Questionnaire Responses
  questionnaireResponses: {
    title: 'Questionnaire Responses',
    loading: 'Loading responses...',
    respondents: 'Respondents',
    questions: 'Questions',
    completed: 'Completed',
    respondentList: 'Respondent list',
    noResponses: 'No responses yet',
    shareToReceive: 'Share your questionnaire to receive responses',
    anonymous: 'Anonymous',
    noAnswer: 'No answer',
    answers: 'answers',
    abandoned: 'Abandoned',
    completedStatus: 'Completed',
    inProgress: 'In progress',
    responseDetails: 'Response details',
    sessionAbandoned: 'Session abandoned',
    noQuestionsAnswered: 'This person started the questionnaire but did not answer any questions.',
    viewFullResults: 'View full results page',
    deleteResponse: 'Delete this response?',
    deleteResponseMessage: 'The response from <strong>{{name}}</strong> will be permanently deleted.',
    responseOf: 'The response from'
  },

  // Quiz Responses
  quizResponses: {
    loading: 'Loading responses...',
    title: 'Quiz Responses',
    participants: 'Participants',
    averageScore: 'Average score',
    averageSuccessRate: 'Average success rate',
    participantsList: 'Participants list',
    noResponses: 'No responses yet',
    shareQuiz: 'Share your quiz to receive responses',
    abandoned: 'Abandoned',
    responseDetails: 'Response details',
    answer: 'Answer',
    correctAnswer: 'Correct answer',
    sessionAbandoned: 'Session abandoned',
    noQuestionsAnswered: 'This person started the quiz but did not answer any questions.',
    viewFullResults: 'View full results page',
    deleteResponse: 'Delete this response?',
    responseOf: 'The response from'
  },

  // Quiz Results
  quizResults: {
    loading: 'Loading results...',
    title: 'Quiz Results',
    totalScore: 'Total score',
    correct: 'Correct',
    incorrect: 'Incorrect',
    success: 'Success',
    viewLeaderboard: 'View leaderboard',
    responseDetails: 'Response details',
    viewAll: 'View all',
    revisionMode: 'Revision mode',
    revisionModeActive: 'Revision mode active',
    showingIncorrect: 'Showing {{count}} incorrect answer(s) only',
    yourAnswer: 'Your answer',
    noAnswer: 'No answer',
    correctAnswer: 'Correct answer',
    points: 'Points',
    time: 'Time',
    replay: 'Replay',
    home: 'Home'
  },

  // Quiz Leaderboard
  quizLeaderboard: {
    loading: 'Loading leaderboard...',
    title: 'Leaderboard',
    share: 'Share',
    uniquePlayers: 'Unique players',
    gamesPlayed: 'Games played',
    highestScore: 'Highest score',
    averageScore: 'Average score',
    filterAll: 'All',
    filterToday: 'Today',
    filterWeek: '7 days',
    filterMonth: '30 days',
    noScores: 'No scores yet',
    beFirst: 'Be the first to play!',
    playNow: 'Play now',
    points: 'points',
    joinLeaderboard: 'Play and join the leaderboard'
  },

  // Join Quiz Live
  joinQuizLive: {
    loading: 'Searching for an active session...',
    liveSession: 'Live session!',
    playersWaiting: '{{count}} player(s) waiting',
    joinSession: 'Join session',
    noSession: 'No active session',
    hostNotStarted: 'The host has not started a session yet',
    hasSessionCode: 'Do you have a session code?',
    sessionCodePlaceholder: 'Session code...',
    or: 'or',
    playSolo: 'Play solo',
    questions: 'questions',
    perQuestion: 's per question'
  },

  // Event Visitors
  eventVisitors: {
    title: 'Registered visitors',
    refresh: 'Refresh',
    totalVisitors: 'Total visitors',
    pdfDownloaded: 'PDFs downloaded',
    lastVisit: 'Last visit',
    visitorsList: 'Visitors list',
    registeredOn: 'Registered on',
    pdfDownloadedStatus: 'PDF downloaded',
    noPdf: 'No PDF',
    generatePdf: 'Generate PDF',
    noVisitors: 'No registered visitors',
    visitorsWillAppear: 'Visitors will appear here when they enter their name',
    deleteVisitor: 'Delete this visitor?',
    deleteVisitorConfirm: 'Do you really want to delete {{name}} from the list?',
    backToDashboard: 'Back to dashboard',
    eventNotFound: 'Event not found',
    unauthorized: 'You are not authorized to view this page',
    loadingError: 'Error loading data',
    pdfGenerated: 'PDF generated for {{name}}',
    pdfError: 'Error generating PDF',
    visitorDeleted: 'Visitor deleted',
    deleteError: 'Error deleting',
    invitation: 'Invitation'
  },

  // Planning (Programs & Menus)
  planning: {
    title: 'Planning',
    subtitle: 'Manage your event programs and menus',
    programs: 'Programs',
    menus: 'Menus',
    shareLinks: 'Share links',
    createProgram: 'Create a program',
    editProgram: 'Edit program',
    createMenu: 'Create a menu',
    editMenu: 'Edit menu',
    noProgramsYet: 'No programs created',
    noMenusYet: 'No menus created',
    noLinksYet: 'No share links generated',
    generateQR: 'Generate QR-Code / Link',
    generateQRTitle: 'Generate a share link',
    generateQRDescription: 'Select the items to share with your guests',
    editQRTitle: 'Edit QR code',
    editQRDescription: 'Add or remove items. The QR code and link stay the same.',
    saveChanges: 'Save',
    linkUpdated: 'QR code updated!',
    generate: 'Generate',
    downloadQR: 'Download QR',
    noContentToShare: 'No content to share',
    createContentFirst: 'Create programs or menus first',
    includeGuestbook: 'Include the guestbook',
    confirmDeleteProgram: 'Are you sure you want to delete this program?',
    confirmDeleteMenu: 'Are you sure you want to delete this menu?',
    selectToView: 'Choose what you want to view',
    invalidLink: 'This share link is no longer valid',
    eventNotFound: 'Event not found',
    noContentAvailable: 'No content available',
    program: {
      info: 'Program information',
      title: 'Program title',
      titlePlaceholder: 'E.g.: The Day Schedule',
      titleRequired: 'Title is required',
      date: 'Date / Period',
      datePlaceholder: 'E.g.: Saturday June 14th',
      dateHint: 'Free text - write as you like',
      items: 'Activities',
      addItem: 'Add an activity',
      addFirstItem: 'Add the first activity',
      noItems: 'No activities in this program',
      activityName: 'Activity name',
      activityNamePlaceholder: 'E.g.: Guest welcome',
      description: 'Description',
      descriptionPlaceholder: 'Describe this activity...',
      bgColor: 'Background color',
      textColor: 'Text color',
      images: 'Images',
      viewMap: 'View map',
      activities: 'activities'
    },
    menu: {
      info: 'Menu information',
      title: 'Menu title',
      titlePlaceholder: 'E.g.: Gala Dinner Menu',
      titleRequired: 'Title is required',
      starters: 'Starters',
      mains: 'Main Courses',
      desserts: 'Desserts',
      dish: 'Dish',
      addDish: 'Add a dish',
      dishName: 'Dish name',
      dishNamePlaceholder: 'E.g.: Homemade foie gras',
      dishDescription: 'Dish description',
      dishDescriptionPlaceholder: 'Describe this dish...',
      dishImage: 'Dish image'
    },
    editor: {
      bold: 'Bold',
      italic: 'Italic',
      textColor: 'Text color',
      mapLinkPlaceholder: 'Google Maps link...'
    }
  },

  // Image Upload
  imageUpload: {
    import: 'Import',
    urlPlaceholder: 'https://example.com/image.jpg',
    uploadInProgress: 'Uploading...',
    imageUploaded: 'Image uploaded',
    deleteImage: 'Delete image',
    clickToSelect: 'Click to select an image',
    maxSize: 'PNG, JPG, GIF up to 5 MB',
    preview: 'Preview',
    selectImage: 'Please select an image',
    maxSizeError: 'Image must not exceed 60 MB',
    maxSizeErrorWithSize: 'Image must not exceed {{size}} MB',
    storageNotConfigured: 'Firebase Storage is not configured. Please enable Storage in the Firebase console.'
  },

  // Tasks
  tasks: {
    title: 'Tasks',
    add: 'Add a task',
    addFirst: 'Add my first task',
    selectTask: 'Choose a task',
    selectTaskDescription: 'Select a predefined task or create a custom one',
    createCustom: 'Create a custom task',
    predefined: 'Predefined wedding tasks',
    newTask: 'New task',
    editTask: 'Edit task',
    taskName: 'Task name',
    taskNamePlaceholder: 'Ex: Book the photographer',
    description: 'Description',
    descriptionPlaceholder: 'Describe the details of this task...',
    deadline: 'Deadline',
    cost: 'Estimated cost',
    responsibles: 'Responsibles',
    responsibleName: 'Name',
    responsibleContact: 'Phone / Email',
    addResponsible: 'Add a responsible',
    location: 'Location',
    locationNamePlaceholder: 'Location name (ex: Martin Photo Studio)',
    locationUrlPlaceholder: 'Google Maps link or directions',
    directions: 'Directions',
    reminder: 'Reminder',
    reminderOn: 'Reminder active',
    setReminder: 'Set a reminder',
    configure: 'Configure',
    venue: 'Venue',
    quantity: 'Quantity',
    notes: 'Notes',
    notesPlaceholder: 'Additional notes...',
    responses: 'Progress updates',
    addResponse: 'Add an update...',
    confirmDelete: 'Are you sure you want to delete this task?',
    all: 'All',
    pending: 'Pending',
    completed: 'Completed',
    overdue: 'Overdue',
    search: 'Search tasks...',
    empty: 'No tasks',
    emptyDescription: 'Start organizing your event by adding tasks',
    markComplete: 'Mark as complete',
    markIncomplete: 'Mark as incomplete',
    today: 'Today',
    tomorrow: 'Tomorrow',
    daysLeft: '{{days}} days left'
  },

  // Notifications
  notifications: {
    title: 'Notifications',
    empty: 'No notifications',
    emptyDescription: 'You will receive task reminders here',
    markAllRead: 'Mark all as read',
    markRead: 'Mark as read',
    viewAll: 'View all notifications',
    new: 'New',
    justNow: 'Just now',
    minutesAgo: '{{count}} min ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
    today: 'Today',
    yesterday: 'Yesterday',
    all: 'All',
    unread: 'Unread',
    read: 'Read',
    unreadCount: '{{count}} unread',
    allRead: 'All notifications read',
    noUnread: 'No unread notifications',
    noRead: 'No read notifications',
    chatEscalation: '💬 New chat waiting',
    chatEscalationMessage: '{{userName}} is requesting human help',
    goToChat: 'View chat'
  },

  // Questionnaire Results
  questionnaireResults: {
    loading: 'Loading results...',
    title: 'Your Responses',
    completedOn: 'Questionnaire completed on',
    unknownDate: 'Unknown date',
    answersRecorded: 'answers recorded',
    responseDetails: 'Response details',
    noAnswer: 'No answer',
    noAnswersRecorded: 'No answers recorded',
    backToHome: 'Back to home'
  },

  // Admin Quiz Music
  adminQuizMusic: {
    loading: 'Loading music...',
    title: 'Quiz Music Management',
    subtitle: 'Manage lobby music, sound effects and gameplay music',
    backToAdmin: 'Back to admin panel',
    lobbyTab: 'Lobby',
    effectsTab: 'Effects',
    gameplayTab: 'Gameplay',
    lobbyMusic: 'Lobby Music',
    lobbyMusicDesc: 'This music is played in random loop in the waiting room.',
    soundEffects: 'Sound Effects',
    soundEffectsDesc: 'These sounds are played at specific moments in the quiz.',
    gameplayMusic: 'Gameplay Music',
    gameplayMusicDesc: 'Each question duration has its own music bank.',
    questionDuration: '{{duration}}s question → ~{{musicDuration}}s music',
    lobbyMusicTitle: '🎵 Lobby Music',
    lobbyMusicSubtitle: 'Played in random loop in the waiting room',
    countdownTitle: '⏱️ Countdown (3-2-1)',
    countdownSubtitle: 'Sound played before the game starts',
    transitionTitle: '🔄 Question Transition',
    transitionSubtitle: 'Short sound between questions',
    resultsTitle: '📊 Results / Statistics',
    resultsSubtitle: 'Music during results display',
    podiumTitle: '🏆 Final Podium',
    podiumSubtitle: 'Celebration music for the podium',
    questionsTitle: '🎮 {{duration}}s Questions',
    questionsSubtitle: 'Music for {{duration}} second questions',
    uploading: 'Uploading...',
    addAudio: 'Click to add audio files',
    noMusic: 'No music',
    unknownError: 'Unknown error'
  },

  services: {
    marketplaceTitle: 'Find the right professional',
    marketplaceSubtitle: 'Trusted professionals for all your needs and projects.',
    searchPlaceholder: 'Search for a service, a business...',
    noServices: 'No services yet',
    noServicesDesc: 'Be the first to offer your service in this category.',
    proposeService: 'Offer a service',
    onQuote: 'On quote',
    views: 'views',
    window: 'Tab',
    notFound: 'Service not found',
    notYours: 'This service does not belong to you',
    updated: 'Service updated!',
    submitted: 'Service submitted! It will be published after review.',
    createService: 'Create a service',
    editTitle: 'Edit service',
    createSubtitle: 'Present your business clearly and attractively.',
    autoTranslateHint: 'Your texts will be automatically translated into the other languages (French, German, Dutch) when published.',
    generalInfo: 'General information',
    businessName: 'Business name',
    serviceTitle: 'Service title',
    titlePlaceholder: 'E.g. Professional Photographer & Videographer',
    tagline: 'Tagline',
    taglinePlaceholder: 'A short sentence summarizing your offer',
    category: 'Category',
    serviceType: 'Service type',
    country: 'Country',
    city: 'City',
    cityPlaceholder: 'Choose or type your city',
    coverImage: 'Cover image',
    profilePhoto: 'Profile photo',
    profilePhotoHint: 'If you do not add a photo, the initials of your name will be shown.',
    price: 'Price (optional)',
    pricePlaceholder: 'E.g. From €350 / On quote',
    priceComment: 'Price note',
    priceCommentPlaceholder: 'E.g. for a 2-hour service',
    contactInfo: 'Contact details',
    contactInfoDesc: 'Choose which details are visible to visitors. A contact form is always shown.',
    email: 'Email',
    showEmail: 'Show my email publicly',
    phone: 'Phone',
    showPhone: 'Show my number publicly',
    windows: 'Windows / Tabs',
    addWindow: 'Add a tab',
    windowTitle: 'Tab title (e.g. Wedding)',
    imageBlock: 'Image',
    textBlock: 'Text',
    textPlaceholder: 'Write your paragraph...',
    captionPlaceholder: 'Image caption (optional)',
    noBlocks: 'Add text or images to this tab.',
    addText: 'Add text',
    addImage: 'Add an image',
    verifyFirst: 'Verify your identity first',
    verifyFirstDesc: 'To publish a service, you must first have your identity verified. This is a one-time, secure step.',
    startVerification: 'Start verification',
    notAvailable: 'Service unavailable',
    notAvailableDesc: 'This service does not exist or is not published yet.',
    backToMarketplace: 'All services',
    previewPending: 'Preview — this service is awaiting admin approval.',
    previewRejected: 'This service has been rejected.',
    previewRestricted: 'The display of this service has been restricted by an administrator.',
    emptyWindow: 'No content in this tab.',
    errors: {
      businessName: 'Enter the business name.',
      title: 'Enter a title for your service.',
      type: 'Choose a service type.',
      country: 'Choose your country.',
      city: 'Enter your city.',
      email: 'Enter a contact email.'
    },
    status: {
      pending: 'Pending review',
      approved: 'Published',
      rejected: 'Rejected',
      restricted: 'Restricted'
    },
    categories: {
      evenement: 'Events', maison: 'Home & Repairs', beaute: 'Beauty & Wellness', formation: 'Lessons & Training', digital: 'IT & Digital', mode: 'Fashion & Sewing', transport: 'Transport & Delivery', autre: 'Other services'
    },
    types: {
      photographe: 'Photographer', videaste: 'Videographer', 'event-planner': 'Event planner', dj: 'DJ', traiteur: 'Caterer', decoration: 'Decoration', animation: 'Entertainment', 'location-salle': 'Venue rental', fleuriste: 'Florist', musicien: 'Musician', mc: 'Master of ceremonies', securite: 'Security', plombier: 'Plumber', electricien: 'Electrician', menuisier: 'Carpenter', peintre: 'Painter', jardinier: 'Gardener', demenagement: 'Moving', nettoyage: 'Cleaning', bricolage: 'Handyman', coiffeur: 'Hairdresser', maquilleur: 'Makeup artist', estheticienne: 'Beautician', manucure: 'Manicure', massage: 'Massage', 'coach-sportif': 'Fitness coach', 'cours-particuliers': 'Private lessons', langues: 'Languages', musique: 'Music', 'soutien-scolaire': 'Tutoring', coaching: 'Coaching', developpeur: 'Developer', graphiste: 'Graphic designer', webdesign: 'Web design', marketing: 'Marketing', redaction: 'Copywriting', 'community-manager': 'Community manager', couture: 'Sewing', stylisme: 'Styling', retouche: 'Alterations', creation: 'Creation', chauffeur: 'Driver', livraison: 'Delivery', vtc: 'Private hire', demenageur: 'Mover', autre: 'Other'
    },
    idDocuments: {
      'carte-identite': 'ID card', 'passeport-ue': 'Passport (European Union)', 'carte-sejour': 'Residence permit', visa: 'Visa', 'permis-conduire': 'Driving license'
    },
    marketplace: {
      navLink: 'Services',
      homeTitle: 'Find the ideal professional',
      homeSubtitle: 'Photographers, DJs, caterers, event planners and more — verified professionals for all your projects.',
      browseAll: 'Browse services',
      becomeProvider: 'Offer my services'
    },
    verify: {
      title: 'Identity verification',
      subtitle: 'A one-time step to become a trusted provider.',
      approvedTitle: 'Identity verified ✅',
      approvedDesc: 'You can now create and publish your services.',
      pendingTitle: 'Verification in progress',
      pendingDesc: 'Our team is reviewing your request. You will be notified by email and in your notifications once it is processed.',
      rejectedTitle: 'Previous request rejected',
      resubmit: 'You can submit new documents below.',
      explain: 'To keep the platform safe, we verify the identity of every provider. Provide a valid ID document and record a short video of yourself so our team can confirm the identity matches you. These documents are confidential and used only for verification purposes.',
      idType: 'ID document type',
      idDocument: 'ID document (image or PDF)',
      uploadFile: 'Upload (image / PDF)',
      scanFile: 'Scan with camera',
      selfieVideo: 'Live selfie video',
      selfieHint: 'Film yourself facing the camera for a few seconds. This video lets us compare your face with your ID.',
      consent: 'I agree that my ID document and video are processed by HugoQuiz for identity verification purposes, in accordance with the terms of use and privacy policy.',
      submit: 'Submit my verification request',
      submitted: 'Your request has been sent to our team.',
      invalidIdFile: 'Please provide an image or a PDF.',
      fileTooLarge: 'File too large (max 30 MB).',
      needId: 'Please provide your ID document.',
      needSelfie: 'Please record your selfie video.',
      needConsent: 'You must accept the conditions.',
      cameraError: 'Unable to access the camera. Allow access and try again.',
      enableCamera: 'Enable camera',
      recorded: 'Video recorded',
      startRecording: 'Start',
      stopRecording: 'Stop',
      retake: 'Retake'
    },
    contact: {
      title: 'Contact',
      intro: 'Describe your need or project in detail and we will get back to you as soon as possible.',
      fullName: 'Full name',
      phone: 'Phone number',
      email: 'Email address',
      emailPlaceholder: 'you@example.com',
      invalidEmail: 'Please enter a valid email.',
      clientType: 'Client type',
      individual: 'Individual',
      company: 'Company',
      subject: 'Subject of the request',
      request: 'Describe your request / the service you need',
      send: 'Send my request',
      sent: 'Your request has been sent!',
      sentTitle: 'Request sent!',
      sentDesc: 'The provider has received your message and will reply soon.',
      fillRequired: 'Please fill in the required fields.',
      consentRequired: 'You must accept the processing of your data.',
      consent: 'I agree that my data is shared with the provider so they can respond to my request.'
    },
    reviews: {
      title: 'Reviews',
      rating: 'rating',
      ratings: 'ratings',
      customerReviews: 'Customer reviews',
      summaryDesc: 'Share your experience with this provider to help other clients.',
      writeReview: 'Write a review',
      yourReview: 'Your review',
      yourRating: 'Your rating',
      yourName: 'Your name',
      yourComment: 'Your comment',
      optional: 'optional',
      commentPlaceholder: 'Describe your experience…',
      commentModerated: 'Comments are reviewed by an administrator before being published.',
      submit: 'Post my review',
      submitted: 'Thanks for your rating!',
      submittedPending: 'Thank you! Your comment will be published after review.',
      pendingNote: 'Your comment is awaiting administrator approval.',
      alreadyReviewed: 'You have already reviewed this service.',
      noReviews: 'No reviews yet. Be the first to leave a review!',
      anonymous: 'Anonymous',
      pickRating: 'Please give a rating.',
      enterName: 'Please enter your name.'
    },
    messages: {
      title: 'Messages received',
      subtitle: 'Requests sent through your services appear here.',
      empty: 'No messages yet'
    }
  }
}
